var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20201107 at Wed Sep 25 18:21:43 2024\n By \nCopyright 2023 The Funnel Project Authors (https://github.com/Dicotype/Funnel)\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FunnelSans-Regular",
    horizAdvX: 660
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Funnel Sans",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1200,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 960,
    descent: -240,
    xHeight: 600,
    capHeight: 810,
    bbox: "-232 -336 1396 1132",
    underlineThickness: 66,
    underlinePosition: -153,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 720,
    d: "M108 -180v990h504v-990h-504zM186 -108h348v846h-348v-846z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 684,
    d: "M128 0v514h-110v86h111v139q0 51 26.5 76t74.5 25h152v-86h-147v-154h135v-86h-134v-514h-108zM482 0v600h108v-600h-108zM536 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 684,
    d: "M128 0v514h-110v86h111v139q0 51 26.5 76t74.5 25h152v-86h-147v-154h135v-86h-134v-514h-108zM482 0v840h108v-840h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 776,
    d: "M128 0v514h-110v86h111v139q0 51 26.5 76t74.5 25h152v-86h-147v-154h282v139q0 51 26.5 76t74.5 25h152v-86h-147v-154h135v-86h-134v-514h-108v514h-280v-514h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 720,
    d: "M108 -180v990h504v-990h-504zM186 -108h348v846h-348v-846z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 400
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 296
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 308,
    d: "M109 248l-10 291v271h110v-270l-10 -292h-90zM154 -12q-31 0 -53.5 22.5t-22.5 53.5t22.5 53t53.5 22q32 0 54 -22t22 -53t-22 -53.5t-54 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 484,
    d: "M76 508v302h90v-302h-90zM318 508v302h90v-302h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    d: "M82 0l45 231h-111v84h127l35 180h-111v84h128l45 231h91l-45 -231h156l45 231h91l-45 -231h111v-84h-127l-35 -180h111v-84h-128l-45 -231h-91l45 231h-156l-45 -231h-91zM228 311h167l37 188h-167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    d: "M305 -90v104q-115 10 -183 75.5t-74 164.5h113q9 -73 58.5 -109.5t129.5 -36.5q75 0 115.5 32t40.5 91q0 47 -28.5 76.5t-90.5 43.5l-117 27q-96 22 -144 73t-48 127q0 87 58 145.5t157 68.5v78h89v-79q95 -13 155 -73.5t69 -153.5h-113q-12 64 -54 99.5t-113 35.5 q-65 0 -103.5 -30.5t-38.5 -81.5q0 -43 28 -70.5t87 -41.5l123 -28q97 -22 143.5 -74.5t46.5 -132.5q0 -93 -57.5 -153t-160.5 -72v-105h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 992,
    d: "M230 378q-78 0 -126 56.5t-48 165.5t48 165.5t126 56.5q76 0 125 -56.5t49 -165.5t-49 -165.5t-125 -56.5zM230 449q40 0 64 37t24 114t-24 114t-64 37q-41 0 -64.5 -37t-23.5 -114t23.5 -114t64.5 -37zM762 -12q-78 0 -126 56.5t-48 165.5t48 165.5t126 56.5 q76 0 125 -56.5t49 -165.5t-49 -165.5t-125 -56.5zM762 59q40 0 64 37t24 114t-24 114t-64 37q-41 0 -64.5 -37t-23.5 -114t23.5 -114t64.5 -37zM228 0l446 810h90l-446 -810h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 768,
    d: "M302 0q-69 0 -124.5 28t-87.5 79.5t-32 121.5q0 63 25 106t63.5 66t76.5 29v4q-51 13 -90 57t-39 111q0 64 29 111t80 72t115 25h176v-98h-163q-56 0 -91.5 -32t-35.5 -91q0 -58 35.5 -90.5t91.5 -32.5h195v134h104v-134h112v-93h-112v-373h-328zM323 98h203v275h-204 q-69 0 -111.5 -34t-42.5 -102q0 -67 43 -103t112 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 242,
    d: "M76 508v302h90v-302h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 342,
    d: "M196 -180q-73 93 -111.5 219t-38.5 272t38.5 273.5t111.5 225.5h112q-76 -103 -117 -232t-41 -266q0 -136 41 -262t117 -230h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 342,
    d: "M34 -180q77 104 117.5 230t40.5 262q0 137 -41 266t-117 232h112q74 -98 112 -225.5t38 -273.5t-38 -272t-112 -219h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 620,
    d: "M193 339l-74 53l69 96l60 70l-89 21l-113 36l29 88l112 -36l85 -37l-8 92v118h92v-118l-8 -92l85 37l112 36l29 -88l-113 -36l-89 -21l60 -70l69 -95l-74 -54l-70 95l-47 79l-48 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M284 129v232h-224v88h224v232h92v-232h224v-88h-224v-232h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 268,
    d: "M35 -162v68h38q27 0 40.5 14t13.5 40v40h-61v134h136v-175q0 -57 -31 -89t-90 -32h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 368,
    d: "M42 252v96h284v-96h-284z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 268,
    d: "M134 -12q-33 0 -56 23t-23 56t23 56t56 23t56 -23t23 -56t-23 -56t-56 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 436,
    d: "M18 -13l298 836h102l-298 -836h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    d: "M330 -12q-133 0 -202 106t-69 311t69 311t202 106t202 -106t69 -311t-69 -311t-202 -106zM330 84q82 0 122.5 80t40.5 241t-40.5 241t-122.5 80t-122.5 -80t-40.5 -241t40.5 -241t122.5 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    d: "M116 0v93h194v592l-204 -156h-4v113l222 168h94v-717h167v-93h-469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    d: "M67 0v82l305 332q38 42 59.5 71t30.5 54t9 52q0 61 -38.5 98t-101.5 37q-68 0 -110 -42.5t-49 -118.5h-105q5 78 39 135.5t92 89.5t135 32q71 0 126.5 -28.5t87 -80t31.5 -118.5q0 -57 -28 -111t-90 -119l-249 -264v-4h381v-97h-525z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    d: "M326 -12q-118 0 -189.5 59t-81.5 167h107q6 -62 49 -96t111 -34q70 0 116 40.5t46 109.5q0 66 -45.5 104t-116.5 38h-84v90h90q67 0 102.5 38t35.5 90q0 60 -40.5 96.5t-98.5 36.5q-68 0 -106.5 -37.5t-48.5 -93.5h-103q5 66 39 116.5t91 80t131 29.5q68 0 122.5 -26 t86.5 -74t32 -115q0 -61 -35.5 -108.5t-93.5 -69.5v-4q65 -18 106.5 -68t41.5 -128q0 -77 -35.5 -131t-95.5 -82t-133 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    d: "M412 0v194h-384v80l386 536h103v-524h115v-92h-115v-194h-105zM138 286h278v383h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    d: "M325 -12q-118 0 -189.5 59t-81.5 167h107q6 -62 48.5 -96t112.5 -34q73 0 118 48.5t45 125.5q0 78 -45.5 127t-118.5 49q-47 0 -86 -18.5t-62 -50.5h-93l51 445h417v-97h-326l-28 -235h5q26 24 62 36.5t80 12.5q74 0 130.5 -33.5t87.5 -92.5t31 -136q0 -82 -33.5 -144.5 t-93.5 -97.5t-138 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M350 -12q-139 0 -213.5 101.5t-74.5 289.5q0 139 35.5 238t101 152t157.5 53q96 0 160 -52t83 -146h-109q-15 50 -49.5 77t-84.5 27q-81 0 -131 -79t-55 -232h4q28 52 78 80t109 28q73 0 127.5 -32.5t85.5 -91.5t31 -138q0 -81 -32 -143t-89.5 -97t-133.5 -35zM346 82 q68 0 111 49t43 126q0 50 -21 90t-59 63t-87 23q-68 0 -112.5 -42.5t-44.5 -106.5q0 -58 22.5 -103.5t61 -72t86.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    d: "M156 0l332 709h-433v101h550v-86l-331 -724h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    d: "M330 -12q-73 0 -134.5 27.5t-98.5 80.5t-37 129t42 125t96 71v4q-46 22 -80 70.5t-34 108.5q0 69 33 117.5t89 74.5t124 26q69 0 124.5 -26t88.5 -74.5t33 -117.5q0 -60 -34 -105.5t-80 -67.5v-4q55 -22 96.5 -74t41.5 -128t-37 -129t-98.5 -80.5t-134.5 -27.5zM330 82 q44 0 81 18t60 52t23 79t-23 78.5t-60 51.5t-81 18t-81 -18t-60 -51.5t-23 -78.5t23 -79t60 -52t81 -18zM330 471q58 0 99.5 34.5t41.5 94.5t-41.5 94.5t-99.5 34.5t-99.5 -34.5t-41.5 -94.5t41.5 -94.5t99.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    d: "M310 -12q-102 0 -169.5 55t-86.5 157h109q14 -58 52.5 -88t94.5 -30q81 0 124.5 81t47.5 239h-4q-26 -49 -73.5 -77t-107.5 -28q-71 0 -125 32.5t-84 91t-30 134.5q0 78 32 138t89 94.5t130 34.5q134 0 207.5 -100.5t73.5 -284.5q0 -144 -32.5 -244.5t-95.5 -152.5 t-152 -52zM325 388q66 0 108.5 41t42.5 104q0 56 -21.5 100t-58 70t-83.5 26q-66 0 -108.5 -47.5t-42.5 -122.5q0 -76 45.5 -123.5t117.5 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 328,
    d: "M164 41q-33 0 -56 23t-23 56t23 56t56 23t56 -23t23 -56t-23 -56t-56 -23zM164 401q-33 0 -56 23t-23 56t23 56t56 23t56 -23t23 -56t-23 -56t-56 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 328,
    d: "M65 -109v68h38q27 0 40.5 14t13.5 40v40h-61v134h136v-175q0 -57 -31 -89t-90 -32h-46zM164 401q-33 0 -56 23t-23 56t23 56t56 23t56 -23t23 -56t-23 -56t-56 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    d: "M585 136l-510 219v100l510 219v-96l-411 -173l411 -173v-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M72 468v88h516v-88h-516zM72 254v88h516v-88h-516z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    d: "M75 136v96l411 173l-411 173v96l510 -219v-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 548,
    d: "M184 248q0 72 19 114.5t67 81.5l50 42q40 33 58 62.5t18 63.5q0 54 -35.5 85t-91.5 31q-53 0 -86 -27t-43 -79h-108q13 92 76 146t163 54q101 0 165.5 -55.5t64.5 -151.5q0 -53 -24 -97.5t-76 -89.5l-65 -55q-33 -27 -45 -52t-14 -73h-93zM229 -12q-31 0 -53 22.5 t-22 53.5t22 53t53 22q32 0 54 -22t22 -53t-22 -53.5t-54 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1080,
    d: "M548 -120q-145 0 -252.5 58t-166.5 161.5t-59 240.5q0 107 35.5 195t101.5 152.5t156.5 99.5t199.5 35q101 0 185 -31.5t145.5 -87.5t95 -132t33.5 -166t-33 -160.5t-89.5 -111t-126.5 -40.5q-48 0 -76 22t-37 66h-4q-42 -88 -144 -88q-62 0 -107.5 32t-70.5 88.5 t-25 131.5t25 132t70.5 88.5t106.5 31.5q102 0 143 -87h4v75h94v-421q54 0 95 31t64 84.5t23 120.5q0 96 -46.5 171.5t-129 119t-193.5 43.5q-120 0 -212 -49.5t-143.5 -137.5t-51.5 -207q0 -111 47.5 -195t135 -130.5t208.5 -46.5h272v-88h-273zM536 175q55 0 88.5 36.5 t33.5 99.5v68q0 64 -33.5 100t-88.5 36q-63 0 -98 -46.5t-35 -123.5t35 -123.5t98 -46.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 762,
    d: "M6 0l315 810h123l312 -810h-115l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 774,
    d: "M109 0v810h347q65 0 115.5 -25t79.5 -72t29 -111q0 -67 -39 -111t-90 -57v-4q39 -6 77 -29t63 -66t25 -106q0 -70 -32 -121.5t-87.5 -79.5t-124.5 -28h-363zM220 98h231q69 0 112 36t43 103q0 68 -42.5 102t-111.5 34h-232v-275zM220 467h223q56 0 91.5 32t35.5 90 q0 59 -35.5 91t-91.5 32h-223v-245z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 792,
    d: "M434 -13q-110 0 -193.5 52.5t-130 146.5t-46.5 219q0 124 46.5 218t130 146.5t193.5 52.5q86 0 154 -31.5t111.5 -90t56.5 -139.5h-115q-12 73 -67.5 117t-139.5 44q-78 0 -136.5 -39.5t-90 -110.5t-31.5 -167t31.5 -167t90 -110.5t136.5 -39.5q84 0 139.5 44t67.5 116 h115q-13 -80 -56.5 -138.5t-111.5 -90.5t-154 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 816,
    d: "M109 0v810h254q121 0 211 -49t139 -140t49 -216q0 -124 -49.5 -215t-139 -140.5t-210.5 -49.5h-254zM220 98h143q93 0 157 38.5t97 107.5t33 161q0 139 -73.5 223t-213.5 84h-143v-614z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 684,
    d: "M624 0h-515v810h515v-98h-404v-244h382v-96h-382v-274h404v-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 644,
    d: "M220 0h-111v810h505v-98h-394v-255h371v-98h-371v-359z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 844,
    d: "M423 -12q-105 0 -186 53t-127 147.5t-46 216.5q0 124 48 218t133.5 146.5t195.5 52.5q86 0 153.5 -32t111 -90t56.5 -139h-115q-12 74 -67 117.5t-139 43.5q-79 0 -139 -39.5t-93 -111t-33 -167.5q0 -93 33 -165.5t92 -114.5t136 -42q63 0 111.5 24.5t77 66t28.5 92.5v51 h-231v93h242q47 0 72 -25t25 -72v-312h-104v118h-4q-23 -57 -84 -93.5t-147 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 854,
    d: "M109 0v810h111v-341h414v341h111v-810h-111v371h-414v-371h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 330,
    d: "M110 0v810h110v-810h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 450,
    d: "M30 0v98h200v712h110v-709q0 -51 -26.5 -76t-74.5 -25h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 752,
    d: "M109 0v810h111v-386h4l360 386h136l-334 -348l345 -462h-134l-291 387l-86 -76v-311h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 646,
    d: "M109 0v810h111v-712h396v-98h-507z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 1036,
    d: "M109 0v810h159l248 -653h4l249 653h158v-810h-111v675h-4l-252 -675h-91l-253 676h-4v-676h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 882,
    d: "M773 0h-124l-433 647h-4v-647h-103v810h122l435 -650h4v650h103v-810z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 870,
    d: "M435 -12q-107 0 -191 51.5t-132 145t-48 220.5q0 128 48 221.5t132 144.5t191 51q108 0 192 -50.5t131.5 -144t47.5 -222.5q0 -127 -48 -221t-131.5 -145t-191.5 -51zM435 88q79 0 137.5 39.5t90 111t31.5 166.5q0 96 -31.5 167.5t-90 110.5t-137.5 39t-137 -39 t-90 -110.5t-32 -167.5q0 -95 32 -166.5t90 -111t137 -39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 734,
    d: "M109 0v810h321q122 0 192.5 -67t70.5 -182q0 -114 -71 -181.5t-192 -67.5h-210v-312h-111zM220 409h204q74 0 116.5 41t42.5 111q0 71 -42.5 111.5t-116.5 40.5h-204v-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 870,
    d: "M483 -186q-48 0 -74.5 25t-26.5 76v77q-93 12 -165 66t-112.5 142.5t-40.5 204.5q0 128 48 221.5t132 144.5t191 51q108 0 192 -50.5t131.5 -144t47.5 -222.5q0 -116 -40.5 -204.5t-111.5 -142t-164 -66.5v-81h215v-97h-222zM435 86q79 0 137.5 39.5t90 111.5t31.5 168 q0 97 -31.5 169t-90 111t-137.5 39t-137 -39t-90 -111t-32 -169q0 -96 32 -168t90 -111.5t137 -39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 796,
    d: "M109 0v810h346q74 0 129.5 -26t87 -75.5t31.5 -120.5q0 -54 -23 -98.5t-74 -71.5v-4q47 0 72 -25.5t25 -72.5v-316h-110v332h-373v-332h-111zM220 427h224q67 0 108.5 37.5t41.5 105.5q0 69 -41.5 106t-108.5 37h-224v-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 724,
    d: "M374 -12q-94 0 -165 32.5t-111.5 90t-45.5 134.5h116q9 -78 64.5 -119t145.5 -41q85 0 131 35.5t46 99.5q0 51 -32.5 84.5t-101.5 47.5l-128 29q-101 22 -154 76t-53 137q0 67 33.5 118.5t95 80.5t144.5 29q85 0 149 -30.5t102.5 -85t46.5 -128.5h-116q-13 73 -62 110.5 t-126 37.5q-72 0 -115.5 -33t-43.5 -90q0 -45 30.5 -76.5t99.5 -46.5l133 -30q103 -23 154.5 -78t51.5 -143q0 -110 -76.5 -175.5t-212.5 -65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 690,
    d: "M400 0h-110v712h-266v98h642v-98h-266v-712z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 824,
    d: "M409 -12q-98 0 -167.5 36t-106.5 103.5t-37 162.5v520h113v-514q0 -98 51 -151t152 -53q103 0 152 56.5t49 146.5v515h111v-522q0 -90 -36 -157.5t-106.5 -105t-174.5 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 766,
    d: "M315 0l-303 810h123l249 -690h4l247 690h119l-303 -810h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1088,
    d: "M244 0l-208 810h117l152 -657h4l176 657h110l185 -657h4l151 657h117l-208 -810h-118l-185 664h-4l-175 -664h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 726,
    d: "M18 0l276 422l-256 388h126l200 -309h4l200 309h120l-256 -386l276 -424h-128l-216 342h-4l-220 -342h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 700,
    d: "M295 0v305l-283 505h126l213 -390h4l213 390h120l-283 -503v-307h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 680,
    d: "M50 0v82l432 630h-414v98h550v-82l-432 -630h444v-98h-580z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 382,
    d: "M88 -180v990h264v-86h-162v-818h162v-86h-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 436,
    d: "M418 -13h-102l-298 836h102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 382,
    d: "M30 -179v86h162v817h-162v86h264v-989h-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M61 150l219 510h100l219 -510h-96l-173 411l-173 -411h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 600,
    d: "M606 -159h-612v78h612v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 600,
    d: "M337 679l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 624,
    d: "M246 -11q-89 0 -144.5 50.5t-55.5 130.5q0 85 55.5 132.5t157.5 47.5h175v30q0 66 -35.5 102.5t-99.5 36.5q-53 0 -87.5 -24.5t-45.5 -69.5h-110q15 87 81 137t164 50q111 0 173.5 -60t62.5 -169v-383h-102v104h-4q-23 -53 -73 -84t-112 -31zM268 79q47 0 84.5 22 t59.5 59.5t22 83.5v24h-168q-58 0 -88.5 -24.5t-30.5 -68.5t33 -70t88 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 692,
    d: "M386 -12q-132 0 -184 110h-4v-98h-107v840h108v-337h4q51 109 183 109q75 0 131 -39t87 -109t31 -164q0 -93 -31 -163.5t-87 -109.5t-131 -39zM357 84q78 0 124 59t46 157t-46 157t-124 59q-75 0 -116.5 -47.5t-41.5 -124.5v-88q0 -77 41.5 -124.5t116.5 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 622,
    d: "M337 -12q-80 0 -143.5 38.5t-100 108.5t-36.5 165q0 96 36.5 166t100 108t143.5 38q63 0 115.5 -23.5t89 -70t50.5 -117.5h-112q-14 59 -52.5 86t-90.5 27q-77 0 -124.5 -58t-47.5 -156q0 -97 47.5 -155.5t124.5 -58.5q55 0 94.5 29t54.5 94h109q-13 -74 -50 -123 t-90 -73.5t-118 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 692,
    d: "M306 -12q-75 0 -131 39t-87 109.5t-31 163.5q0 94 31 164t87 109t131 39q132 0 183 -109h4v337h108v-840h-107v98h-4q-52 -110 -184 -110zM335 84q75 0 116.5 47.5t41.5 124.5v88q0 77 -41.5 124.5t-116.5 47.5q-77 0 -123.5 -59t-46.5 -157t46.5 -157t123.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 650,
    d: "M339 -12q-81 0 -145 38.5t-100.5 109t-36.5 166.5q0 95 36 164.5t98 107.5t142 38q75 0 133.5 -34t92.5 -98t34 -151v-48h-432q6 -91 54 -145t123 -54q54 0 92 27t51 74h110q-12 -61 -48 -104.5t-88 -67t-116 -23.5zM166 363h322q-7 74 -49 115t-107 41q-64 0 -108 -41.5 t-58 -114.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 388,
    d: "M128 0v514h-110v86h111v139q0 51 26.5 76t74.5 25h152v-86h-147v-154h135v-86h-134v-514h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 694,
    d: "M327 -252q-111 0 -185 53.5t-86 142.5h115q10 -48 51 -75t103 -27q80 0 125.5 46t45.5 125v97h-4q-22 -53 -68.5 -81.5t-109.5 -28.5q-76 0 -133.5 38.5t-89.5 107.5t-32 160t32 160t89.5 107.5t133.5 38.5q63 0 109.5 -28.5t68.5 -80.5h4v97h107v-592q0 -120 -74.5 -190 t-201.5 -70zM340 98q71 0 113 46t42 122v80q0 76 -42.5 122t-112.5 46q-79 0 -126 -56.5t-47 -151.5t47 -151.5t126 -56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 694,
    d: "M91 0v840h108v-328h4q26 46 73 73t110 27q65 0 115 -31t78 -86t28 -128v-367h-108v351q0 78 -39.5 121t-110.5 43t-110.5 -43t-39.5 -121v-351h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 296,
    d: "M94 0v600h108v-600h-108zM148 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 290,
    d: "M-19 -240v86h115v754h108v-739q0 -51 -26.5 -76t-73.5 -25h-123zM150 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 632,
    d: "M91 0v840h108v-510h4l260 270h130l-246 -251l269 -349h-131l-213 281l-73 -65v-216h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 296,
    d: "M94 0v840h108v-840h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1048,
    d: "M91 0v600h106v-97h4q23 53 67.5 80.5t104.5 27.5q61 0 108.5 -29.5t72.5 -84.5h3q30 55 78 84.5t111 29.5q64 0 113 -29.5t75.5 -83.5t26.5 -127v-371h-108v355q0 75 -36 116.5t-100 41.5q-63 0 -100 -41.5t-37 -116.5v-355h-108v355q0 75 -36.5 116.5t-100.5 41.5 q-63 0 -99.5 -41.5t-36.5 -116.5v-355h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 694,
    d: "M91 0v600h107v-97h4q26 52 73 80t111 28q65 0 115 -31.5t78 -86.5t28 -126v-367h-108v348q0 77 -39.5 121t-110.5 44t-110.5 -44t-39.5 -121v-348h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 680,
    d: "M340 -12q-81 0 -145 38.5t-101 108.5t-37 165q0 96 37 166t101 108t145 38q83 0 147 -38t100 -108t36 -166q0 -95 -36.5 -165.5t-100.5 -108.5t-146 -38zM340 86q80 0 127.5 58.5t47.5 155.5q0 98 -47.5 156t-127.5 58q-79 0 -127 -58t-48 -156q0 -97 48 -155.5 t127 -58.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 692,
    d: "M91 -240v840h107v-98h4q52 110 184 110q75 0 131 -39t87 -109t31 -164q0 -93 -31 -163.5t-87 -109.5t-131 -39q-132 0 -183 109h-4v-337h-108zM357 84q78 0 124 59t46 157t-46 157t-124 59q-75 0 -116.5 -47.5t-41.5 -124.5v-88q0 -77 41.5 -123.5t116.5 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 692,
    d: "M493 -240v337h-4q-51 -109 -183 -109q-75 0 -131 39t-87 109.5t-31 163.5q0 94 31 164t87 109t131 39q132 0 184 -110h4v98h107v-840h-108zM335 84q75 2 116.5 48.5t41.5 123.5v88q0 77 -41.5 124.5t-116.5 47.5q-77 0 -123.5 -59t-46.5 -157t46.5 -157t123.5 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 464,
    d: "M102 0v600h103v-120h4q20 56 65.5 90.5t111.5 34.5h44v-96h-50q-83 0 -126.5 -53t-43.5 -143v-313h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 568,
    d: "M297 -12q-108 0 -175.5 53.5t-73.5 143.5h106q7 -52 45 -79.5t102 -27.5q59 0 90 23t31 65q0 66 -91 85l-99 22q-162 34 -162 160q0 80 60 129.5t157 49.5q96 0 158.5 -50.5t70.5 -136.5h-104q-10 47 -43.5 72.5t-86.5 25.5q-51 0 -81 -22t-30 -60q0 -30 21 -48.5 t67 -28.5l100 -21q82 -18 122.5 -59.5t40.5 -108.5q0 -86 -60 -136.5t-165 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 408,
    d: "M218 0q-46 0 -72 24.5t-26 73.5v416h-102v86h103v180h106v-180h143v-86h-142v-428h156v-86h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 694,
    d: "M306 -11q-65 0 -114.5 30t-77 84t-27.5 124v373h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -73 -85.5t-113 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 596,
    d: "M238 0l-232 600h112l181 -485h4l179 485h108l-232 -600h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 920,
    d: "M190 0l-172 600h110l126 -467h4l147 467h112l147 -467h4l126 467h108l-172 -600h-120l-148 468h-4l-148 -468h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 596,
    d: "M18 0l215 307l-205 293h123l148 -217l148 217h121l-205 -293l215 -307h-123l-158 231l-157 -231h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 596,
    d: "M66 -240v86h136l55 151l-251 603h112l191 -469h4l168 469h109l-226 -600l-53 -141q-18 -47 -38.5 -73t-68.5 -26h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 560,
    d: "M50 0v74l327 438h-309v88h436v-74l-327 -438h333v-88h-460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 432,
    d: "M402 -180q-84 0 -136.5 18.5t-76.5 58t-24 100.5v165q0 59 -31 83.5t-100 24.5v90q71 1 101 25.5t30 82.5v165q0 61 24.5 100t77 58t135.5 19v-89q-75 0 -103.5 -22.5t-28.5 -80.5v-162q0 -63 -28 -96t-90 -43v-4q62 -9 90 -41.5t28 -96.5v-164q0 -57 28 -79.5t104 -22.5 v-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 600,
    d: "M256 -180v1020h88v-1020h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 432,
    d: "M30 -180v89q75 0 103.5 22.5t28.5 80.5v162q0 63 28.5 96t89.5 43v4q-62 9 -90 41.5t-28 96.5v164q0 57 -28 79.5t-104 22.5v89q85 0 137 -18.5t76 -57.5t24 -101v-165q0 -59 30.5 -83.5t100.5 -24.5v-90q-71 -1 -101 -25t-30 -83v-165q0 -60 -24.5 -99.5t-77 -58.5 t-135.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M76 325h-4v101q27 30 60 45t71 15q49 0 90 -17.5t80.5 -35t82.5 -17.5q37 0 69 17.5t59 51.5h4v-101q-27 -30 -59.5 -45t-71.5 -15q-49 0 -90 17.5t-80.5 35t-82.5 17.5q-37 0 -69 -17.5t-59 -51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 296
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 308,
    d: "M199 352l10 -291v-271h-110v270l10 292h90zM154 612q32 0 54 -22t22 -54q0 -31 -22 -53t-54 -22q-31 0 -53.5 22t-22.5 53q0 32 22.5 54t53.5 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    d: "M312 -12v108q-69 10 -123 50.5t-84.5 106.5t-30.5 152q0 87 30.5 153t84.5 106t123 50v96h88v-97q78 -11 134.5 -63t74.5 -144h-112q-15 59 -53 86t-90 27q-77 0 -124.5 -58t-47.5 -156q0 -97 47.5 -155.5t124.5 -58.5q55 0 94.5 29t53.5 94h110q-17 -97 -74.5 -151 t-137.5 -66v-109h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M68 0v85q44 14 69.5 56.5t17.5 125.5l-8 86h-129v84h122l-10 123q-7 83 21.5 141.5t84 89.5t126.5 31q97 0 158.5 -53.5t73.5 -146.5h-106q-9 51 -41 78.5t-84 27.5q-62 0 -100 -43t-30 -133l11 -115h220v-84h-213l7 -82q7 -75 -13.5 -112.5t-62.5 -58.5v-4h421v-96h-535 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    d: "M142 156l-61 61l90 91q-12 21 -19.5 45.5t-7.5 51.5q0 52 26 96l-89 88l64 65l89 -90q44 27 96 27q27 0 51.5 -7t45.5 -20l91 90l61 -61l-90 -91q13 -21 20 -45.5t7 -51.5q0 -52 -27 -96l90 -88l-65 -65l-88 90q-44 -27 -96 -27q-27 0 -51.5 7.5t-45.5 19.5zM330 301 q43 0 73.5 30.5t30.5 73.5t-30.5 73.5t-73.5 30.5t-73.5 -30.5t-30.5 -73.5t30.5 -73.5t73.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    d: "M277 0v167h-185v73h185v90h-185v73h152l-218 407h124l181 -354h4l181 354h118l-219 -407h153v-73h-185v-90h185v-73h-185v-167h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 600,
    d: "M256 444v396h88v-396h-88zM256 -180v396h88v-396h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    d: "M336 -192q-124 0 -201.5 61.5t-84.5 165.5h111q9 -64 55 -98.5t124 -34.5q71 0 109.5 29t38.5 82q0 85 -111 109l-132 29q-90 20 -137.5 65.5t-47.5 112.5q0 100 105 144v4q-43 22 -65 57.5t-22 85.5q0 60 31 105.5t86.5 71t128.5 25.5q110 0 182 -58t81 -157h-110 q-11 59 -52 91t-107 32q-62 0 -98.5 -28t-36.5 -75q0 -77 109 -100l135 -29q91 -19 137.5 -65.5t46.5 -117.5q0 -48 -23 -82t-72 -61v-4q77 -44 77 -147q0 -98 -69.5 -155.5t-187.5 -57.5zM447 202q61 33 61 92q0 91 -113 113l-161 35q-33 -12 -52 -36.5t-19 -58.5 q0 -79 110 -104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 600,
    d: "M421 684q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM179 684q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 1080,
    d: "M540 -132q-99 0 -185 37t-152 103t-103 152t-37 185t37 185t103 152t152 103t185 37t185 -37t152 -103t103 -152t37 -185t-37 -185t-103 -152t-152 -103t-185 -37zM540 -44q81 0 151.5 30t124 83.5t83.5 124.5t30 151q0 81 -30 151.5t-83.5 124t-124 83.5t-151.5 30 q-80 0 -151 -30t-124.5 -83.5t-83.5 -124t-30 -151.5q0 -80 30 -151t83.5 -124.5t124.5 -83.5t151 -30zM541 93q-65 0 -117 31t-81.5 88t-29.5 133q0 77 29.5 133.5t81.5 87.5t117 31q76 0 133 -43t75 -129h-96q-12 49 -42 71t-70 22q-62 0 -99 -47.5t-37 -125.5 q0 -77 37 -124.5t99 -47.5q43 0 73.5 24t42.5 75h93q-15 -90 -73.5 -134.5t-135.5 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 380,
    d: "M148 384q-51 0 -82.5 28.5t-31.5 75.5q0 48 33 75t93 27h88v15q0 29 -17.5 46.5t-47.5 17.5q-24 0 -41.5 -11.5t-23.5 -34.5h-79q9 52 48 80.5t97 28.5q65 0 101.5 -34t36.5 -95v-213h-72v51h-3q-13 -27 -39 -42t-60 -15zM165 447q36 0 59.5 22.5t23.5 56.5v9h-84 q-58 0 -58 -43q0 -21 16 -33t43 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 630,
    d: "M210 55l-172 245l172 245h112l-172 -245l172 -245h-112zM480 55l-172 245l172 245h112l-172 -245l172 -245h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    d: "M477 187v172h-405v92h496v-264h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 1080,
    d: "M540 -132q-99 0 -185.5 37t-152.5 103t-103.5 152t-37.5 185t37.5 185t103.5 152t152.5 103t185.5 37t185.5 -37t152.5 -103t103.5 -152t37.5 -185t-37.5 -185t-103.5 -152t-152.5 -103t-185.5 -37zM540 -44q81 0 151.5 30t124 83.5t83.5 124.5t30 151q0 81 -30 151.5 t-83.5 124t-124 83.5t-151.5 30q-80 0 -151 -30t-124.5 -83.5t-83.5 -124t-30 -151.5q0 -80 30 -151t83.5 -124.5t124.5 -83.5t151 -30zM351 105v480h230q71 0 115.5 -37t44.5 -105q0 -39 -16.5 -67t-48.5 -42v-4q31 0 48 -18t17 -52v-155h-91v165h-208v-165h-91zM442 348 h127q36 0 59 20.5t23 57.5t-23 57.5t-59 20.5h-127v-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 600,
    d: "M110 711v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 480,
    d: "M240 467q-49 0 -89.5 24t-64.5 64.5t-24 89.5t24 89.5t64.5 64.5t89.5 24t89.5 -24t64.5 -64.5t24 -89.5t-24 -89.5t-64.5 -64.5t-89.5 -24zM240 544q42 0 71.5 30t29.5 71q0 42 -29.5 71.5t-71.5 29.5q-41 0 -71 -29.5t-30 -71.5q0 -41 30 -71t71 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    d: "M284 279v172h-224v88h224v172h92v-172h224v-88h-224v-172h-92zM72 85v88h516v-88h-516z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B2",
    unicode: "\xB2",
    horizAdvX: 460,
    d: "M74 600v56l173 164q30 28 40 46.5t10 38.5q0 26 -19 42.5t-49 16.5q-31 0 -53 -18.5t-26 -54.5h-76q4 64 46 102.5t110 38.5q64 0 104.5 -34.5t40.5 -91.5q0 -35 -16.5 -64.5t-53.5 -63.5l-114 -106v-2h190v-70h-307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B3",
    unicode: "\xB3",
    horizAdvX: 460,
    d: "M228 588q-71 0 -113.5 33.5t-47.5 94.5h80q3 -28 24.5 -43t54.5 -15q35 0 57.5 17.5t22.5 48.5q0 28 -22 44.5t-58 16.5h-46v66h48q32 0 50 16t18 39q0 26 -20 42.5t-49 16.5q-31 0 -51 -15.5t-25 -45.5h-77q4 57 46.5 92.5t109.5 35.5q61 0 102 -31.5t41 -84.5 q0 -29 -18 -53t-49 -38v-3q35 -10 57.5 -36.5t22.5 -64.5q0 -61 -45.5 -97t-112.5 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 600,
    d: "M181 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    d: "M274 -180v493q-115 4 -182.5 70.5t-67.5 177.5q0 115 71 182t193 67h77v-990h-91zM464 -180v990h90v-990h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 268,
    d: "M134 221q-33 0 -56 23t-23 56t23 56t56 23t56 -23t23 -56t-23 -56t-56 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 600,
    d: "M184 -268v76h129v28q0 37 -27 51.5t-71 19.5l63 123h76l-45 -89q41 -8 69.5 -32.5t28.5 -82.5q0 -40 -23.5 -67t-68.5 -27h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B9",
    unicode: "\xB9",
    horizAdvX: 460,
    d: "M224 600v329l-114 -78h-2v82l126 87h70v-420h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 404,
    d: "M202 378q-72 0 -118.5 48.5t-46.5 128.5t46.5 128.5t118.5 48.5q73 0 119 -47.5t46 -129.5t-46 -129.5t-119 -47.5zM202 449q39 0 62.5 29t23.5 77q0 49 -23.5 77.5t-62.5 28.5q-37 0 -61.5 -28.5t-24.5 -77.5q0 -48 24.5 -77t61.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 630,
    d: "M38 55l172 245l-172 245h112l172 -245l-172 -245h-112zM308 55l172 245l-172 245h112l172 -245l-172 -245h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 1092,
    d: "M224 390v329l-114 -78h-2v82l126 87h70v-420h-80zM798 0v93h-212v55l216 272h74v-263h59v-64h-59v-93h-78zM668 157h133v165h-2zM248 0l446 810h90l-446 -810h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 1069,
    d: "M224 390v329l-114 -78h-2v82l126 87h70v-420h-80zM606 0v56l173 164q30 28 40 46.5t10 38.5q0 26 -19 42.5t-49 16.5q-31 0 -53 -18.5t-26 -54.5h-76q4 64 46 102.5t110 38.5q64 0 104.5 -34.5t40.5 -91.5q0 -35 -16.5 -64.5t-53.5 -63.5l-114 -106v-2h190v-70h-307z M218 0l446 810h90l-446 -810h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 1010,
    d: "M228 378q-71 0 -113.5 33.5t-47.5 94.5h80q3 -28 24.5 -43t54.5 -15q35 0 57.5 17.5t22.5 48.5q0 28 -22 44.5t-58 16.5h-46v66h48q32 0 50 16t18 39q0 26 -20 42.5t-49 16.5q-31 0 -51 -15.5t-25 -45.5h-77q4 57 46.5 92.5t109.5 35.5q61 0 102 -31.5t41 -84.5 q0 -29 -18 -53t-49 -38v-3q35 -10 57.5 -36.5t22.5 -64.5q0 -61 -45.5 -97t-112.5 -36zM798 0v93h-212v55l216 272h74v-263h59v-64h-59v-93h-78zM668 157h133v165h-2zM258 0l446 810h90l-446 -810h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 548,
    d: "M364 352q0 -72 -19 -114.5t-67 -81.5l-50 -42q-40 -33 -58 -62t-18 -64q0 -54 35.5 -85t91.5 -31q54 0 86.5 27t42.5 79h108q-13 -92 -75.5 -146t-163.5 -54t-165.5 55.5t-64.5 151.5q0 53 24 98t76 89l65 55q33 27 45 52t14 73h93zM319 612q32 0 53.5 -22t21.5 -54 q0 -31 -21.5 -53t-53.5 -22q-31 0 -53.5 22t-22.5 53q0 32 22.5 54t53.5 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 762,
    d: "M6 0l315 810h123l312 -810h-115l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4zM371 889l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 762,
    d: "M6 0l315 810h123l312 -810h-115l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4zM311 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 762,
    d: "M6 0l315 810h123l312 -810h-115l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4zM190 889v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 762,
    d: "M6 0l315 810h123l312 -810h-115l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4zM177 887q4 72 36 111.5t85 39.5q34 0 63.5 -17t56 -34t50.5 -17q46 0 59 68h62q-5 -71 -37 -111t-85 -40q-32 0 -61.5 17t-56 34t-51.5 17t-39 -16.5t-20 -51.5h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 762,
    d: "M6 0l315 810h123l312 -810h-115l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4zM503 894q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM261 894q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5 q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 762,
    d: "M6 0l315 810h123l312 -810h-115l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4zM382 854q-38 0 -70.5 18.5t-51.5 50t-19 70.5q0 40 19 71t51.5 49.5t70.5 18.5q39 0 71 -18.5t51 -49.5t19 -71q0 -39 -19 -70.5t-51 -50t-71 -18.5zM382 923q29 0 49.5 20t20.5 50 t-20.5 50t-49.5 20t-49.5 -20t-20.5 -50t20.5 -50t49.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 1108,
    d: "M6 0l315 810h506l36 -98h-381l94 -244h354l36 -96h-353l105 -274h371l37 -98h-485l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 792,
    d: "M434 -13q-110 0 -193.5 52.5t-130 146.5t-46.5 219q0 124 46.5 218t130 146.5t193.5 52.5q86 0 154 -31.5t111.5 -90t56.5 -139.5h-115q-12 73 -67.5 117t-139.5 44q-78 0 -136.5 -39.5t-90 -110.5t-31.5 -167t31.5 -167t90 -110.5t136.5 -39.5q84 0 139.5 44t67.5 116 h115q-13 -80 -56.5 -138.5t-111.5 -90.5t-154 -32zM318 -268v76h129v28q0 37 -27 51.5t-71 19.5l63 123h76l-45 -89q41 -8 69.5 -32.5t28.5 -82.5q0 -40 -23.5 -67t-68.5 -27h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 684,
    d: "M624 0h-515v810h515v-98h-404v-244h382v-96h-382v-274h404v-98zM356 889l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 684,
    d: "M624 0h-515v810h515v-98h-404v-244h382v-96h-382v-274h404v-98zM296 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 684,
    d: "M624 0h-515v810h515v-98h-404v-244h382v-96h-382v-274h404v-98zM175 889v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 684,
    d: "M624 0h-515v810h515v-98h-404v-244h382v-96h-382v-274h404v-98zM488 894q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM246 894q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5 t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 330,
    d: "M110 0v810h110v-810h-110zM154 889l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 330,
    d: "M110 0v810h110v-810h-110zM94 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 330,
    d: "M110 0v810h110v-810h-110zM-27 889v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 330,
    d: "M110 0v810h110v-810h-110zM286 894q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM44 894q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 846,
    d: "M139 0v375h-109v90h109v345h254q121 0 211 -49t139 -140t49 -216q0 -124 -49.5 -215t-139 -140.5t-210.5 -49.5h-254zM250 98h143q93 0 157 38.5t97 107.5t33 161q0 139 -73.5 223t-213.5 84h-143v-247h224v-90h-224v-277z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 882,
    d: "M773 0h-124l-433 647h-4v-647h-103v810h122l435 -650h4v650h103v-810zM243 887q4 72 36 111.5t85 39.5q34 0 63.5 -17t56 -34t50.5 -17q46 0 59 68h62q-5 -71 -37 -111t-85 -40q-32 0 -61.5 17t-56 34t-51.5 17t-39 -16.5t-20 -51.5h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 870,
    d: "M435 -12q-107 0 -191 51.5t-132 145t-48 220.5q0 128 48 221.5t132 144.5t191 51q108 0 192 -50.5t131.5 -144t47.5 -222.5q0 -127 -48 -221t-131.5 -145t-191.5 -51zM435 88q79 0 137.5 39.5t90 111t31.5 166.5q0 96 -31.5 167.5t-90 110.5t-137.5 39t-137 -39 t-90 -110.5t-32 -167.5q0 -95 32 -166.5t90 -111t137 -39.5zM424 889l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 870,
    d: "M435 -12q-107 0 -191 51.5t-132 145t-48 220.5q0 128 48 221.5t132 144.5t191 51q108 0 192 -50.5t131.5 -144t47.5 -222.5q0 -127 -48 -221t-131.5 -145t-191.5 -51zM435 88q79 0 137.5 39.5t90 111t31.5 166.5q0 96 -31.5 167.5t-90 110.5t-137.5 39t-137 -39 t-90 -110.5t-32 -167.5q0 -95 32 -166.5t90 -111t137 -39.5zM364 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 870,
    d: "M435 -12q-107 0 -191 51.5t-132 145t-48 220.5q0 128 48 221.5t132 144.5t191 51q108 0 192 -50.5t131.5 -144t47.5 -222.5q0 -127 -48 -221t-131.5 -145t-191.5 -51zM435 88q79 0 137.5 39.5t90 111t31.5 166.5q0 96 -31.5 167.5t-90 110.5t-137.5 39t-137 -39 t-90 -110.5t-32 -167.5q0 -95 32 -166.5t90 -111t137 -39.5zM243 889v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 870,
    d: "M435 -12q-107 0 -191 51.5t-132 145t-48 220.5q0 128 48 221.5t132 144.5t191 51q108 0 192 -50.5t131.5 -144t47.5 -222.5q0 -127 -48 -221t-131.5 -145t-191.5 -51zM435 88q79 0 137.5 39.5t90 111t31.5 166.5q0 96 -31.5 167.5t-90 110.5t-137.5 39t-137 -39 t-90 -110.5t-32 -167.5q0 -95 32 -166.5t90 -111t137 -39.5zM229 887q4 72 36 111.5t85 39.5q34 0 63.5 -17t56 -34t50.5 -17q46 0 59 68h62q-5 -71 -37 -111t-85 -40q-32 0 -61.5 17t-56 34t-51.5 17t-39 -16.5t-20 -51.5h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 870,
    d: "M435 -12q-107 0 -191 51.5t-132 145t-48 220.5q0 128 48 221.5t132 144.5t191 51q108 0 192 -50.5t131.5 -144t47.5 -222.5q0 -127 -48 -221t-131.5 -145t-191.5 -51zM435 88q79 0 137.5 39.5t90 111t31.5 166.5q0 96 -31.5 167.5t-90 110.5t-137.5 39t-137 -39 t-90 -110.5t-32 -167.5q0 -95 32 -166.5t90 -111t137 -39.5zM556 894q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM314 894q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5 t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    d: "M142 156l-61 61l186 187l-186 185l64 65l186 -186l187 186l61 -61l-186 -187l186 -185l-65 -65l-185 186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 870,
    d: "M158 -47l-66 47l75 104q-49 54 -76 130.5t-27 170.5q0 128 48 221.5t132 144.5t191 51q117 0 204 -59l67 94l66 -47l-71 -100q49 -53 77 -130.5t28 -174.5q0 -127 -48 -221t-131.5 -145t-191.5 -51q-59 0 -111.5 16t-96.5 46zM232 193l348 486q-63 44 -145 44 q-79 0 -137.5 -39t-91 -110.5t-32.5 -168.5q0 -65 15 -118t43 -94zM435 87q80 0 138.5 39.5t90.5 111t32 167.5q0 131 -60 215l-349 -486q62 -47 148 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 824,
    d: "M409 -12q-98 0 -167.5 36t-106.5 103.5t-37 162.5v520h113v-514q0 -98 51 -151t152 -53q103 0 152 56.5t49 146.5v515h111v-522q0 -90 -36 -157.5t-106.5 -105t-174.5 -37.5zM402 889l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 824,
    d: "M409 -12q-98 0 -167.5 36t-106.5 103.5t-37 162.5v520h113v-514q0 -98 51 -151t152 -53q103 0 152 56.5t49 146.5v515h111v-522q0 -90 -36 -157.5t-106.5 -105t-174.5 -37.5zM342 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 824,
    d: "M409 -12q-98 0 -167.5 36t-106.5 103.5t-37 162.5v520h113v-514q0 -98 51 -151t152 -53q103 0 152 56.5t49 146.5v515h111v-522q0 -90 -36 -157.5t-106.5 -105t-174.5 -37.5zM221 889v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 824,
    d: "M409 -12q-98 0 -167.5 36t-106.5 103.5t-37 162.5v520h113v-514q0 -98 51 -151t152 -53q103 0 152 56.5t49 146.5v515h111v-522q0 -90 -36 -157.5t-106.5 -105t-174.5 -37.5zM534 894q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5 t-19.5 -46.5t-46.5 -19.5zM292 894q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 700,
    d: "M295 0v305l-283 505h126l213 -390h4l213 390h120l-283 -503v-307h-110zM281 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 734,
    d: "M109 0v810h111v-147h210q122 0 192.5 -67t70.5 -182q0 -114 -71 -181.5t-192 -67.5h-210v-165h-111zM220 262h204q74 0 116.5 41t42.5 111q0 71 -42.5 111.5t-116.5 40.5h-204v-304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 692,
    d: "M285 -1v92h59q85 0 134 42.5t49 117.5t-49 117t-133 42h-60v92h50q70 0 108.5 35t38.5 97t-35.5 96t-99.5 34q-68 0 -108 -42t-40 -123v-599h-108v605q0 74 31 129.5t89 86.5t138 31q74 0 128 -26.5t83.5 -73.5t29.5 -108q0 -69 -37.5 -115.5t-100.5 -60.5v-4 q50 -5 92 -34t66.5 -76.5t24.5 -108.5q0 -73 -34 -128t-94 -86t-139 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 624,
    d: "M246 -11q-89 0 -144.5 50.5t-55.5 130.5q0 85 55.5 132.5t157.5 47.5h175v30q0 66 -35.5 102.5t-99.5 36.5q-53 0 -87.5 -24.5t-45.5 -69.5h-110q15 87 81 137t164 50q111 0 173.5 -60t62.5 -169v-383h-102v104h-4q-23 -53 -73 -84t-112 -31zM268 79q47 0 84.5 22 t59.5 59.5t22 83.5v24h-168q-58 0 -88.5 -24.5t-30.5 -68.5t33 -70t88 -26zM292 679l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 624,
    d: "M246 -11q-89 0 -144.5 50.5t-55.5 130.5q0 85 55.5 132.5t157.5 47.5h175v30q0 66 -35.5 102.5t-99.5 36.5q-53 0 -87.5 -24.5t-45.5 -69.5h-110q15 87 81 137t164 50q111 0 173.5 -60t62.5 -169v-383h-102v104h-4q-23 -53 -73 -84t-112 -31zM268 79q47 0 84.5 22 t59.5 59.5t22 83.5v24h-168q-58 0 -88.5 -24.5t-30.5 -68.5t33 -70t88 -26zM232 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 624,
    d: "M246 -11q-89 0 -144.5 50.5t-55.5 130.5q0 85 55.5 132.5t157.5 47.5h175v30q0 66 -35.5 102.5t-99.5 36.5q-53 0 -87.5 -24.5t-45.5 -69.5h-110q15 87 81 137t164 50q111 0 173.5 -60t62.5 -169v-383h-102v104h-4q-23 -53 -73 -84t-112 -31zM268 79q47 0 84.5 22 t59.5 59.5t22 83.5v24h-168q-58 0 -88.5 -24.5t-30.5 -68.5t33 -70t88 -26zM111 679v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 624,
    d: "M246 -11q-89 0 -144.5 50.5t-55.5 130.5q0 85 55.5 132.5t157.5 47.5h175v30q0 66 -35.5 102.5t-99.5 36.5q-53 0 -87.5 -24.5t-45.5 -69.5h-110q15 87 81 137t164 50q111 0 173.5 -60t62.5 -169v-383h-102v104h-4q-23 -53 -73 -84t-112 -31zM268 79q47 0 84.5 22 t59.5 59.5t22 83.5v24h-168q-58 0 -88.5 -24.5t-30.5 -68.5t33 -70t88 -26zM97 677q4 72 36 111.5t85 39.5q34 0 63.5 -17t56 -34t50.5 -17q46 0 59 68h62q-5 -71 -37 -111t-85 -40q-32 0 -61.5 17t-56 34t-51.5 17t-39 -16.5t-20 -51.5h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 624,
    d: "M246 -11q-89 0 -144.5 50.5t-55.5 130.5q0 85 55.5 132.5t157.5 47.5h175v30q0 66 -35.5 102.5t-99.5 36.5q-53 0 -87.5 -24.5t-45.5 -69.5h-110q15 87 81 137t164 50q111 0 173.5 -60t62.5 -169v-383h-102v104h-4q-23 -53 -73 -84t-112 -31zM268 79q47 0 84.5 22 t59.5 59.5t22 83.5v24h-168q-58 0 -88.5 -24.5t-30.5 -68.5t33 -70t88 -26zM424 684q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM182 684q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5 t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 624,
    d: "M246 -11q-89 0 -144.5 50.5t-55.5 130.5q0 85 55.5 132.5t157.5 47.5h175v30q0 66 -35.5 102.5t-99.5 36.5q-53 0 -87.5 -24.5t-45.5 -69.5h-110q15 87 81 137t164 50q111 0 173.5 -60t62.5 -169v-383h-102v104h-4q-23 -53 -73 -84t-112 -31zM268 79q47 0 84.5 22 t59.5 59.5t22 83.5v24h-168q-58 0 -88.5 -24.5t-30.5 -68.5t33 -70t88 -26zM303 674q-34 0 -63 16.5t-46 44.5t-17 63t17 63t46 44.5t63 16.5q35 0 63.5 -16.5t45.5 -44.5t17 -63t-17 -63t-45.5 -44.5t-63.5 -16.5zM303 737q25 0 43 17t18 44t-18 44t-43 17t-43 -17t-18 -44 t18 -44t43 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 1030,
    d: "M719 -12q-74 0 -134 32.5t-95 90.5h-4q-66 -122 -233 -122q-93 0 -150 52t-57 136q0 88 56 137t160 49h178v17q0 66 -36 102.5t-102 36.5q-55 0 -90 -24.5t-46 -69.5h-110q15 87 81.5 137t166.5 50q73 0 124.5 -27.5t77.5 -77.5h4q36 50 88.5 77.5t114.5 27.5 q75 0 133.5 -34.5t91.5 -98.5t33 -150v-48h-427q5 -91 53 -145t122 -54q51 0 89 27t51 74h110q-19 -91 -87.5 -143t-162.5 -52zM271 79q49 0 87 22t60 59.5t22 83.5v37h-171q-60 0 -91 -26.5t-31 -72.5q0 -48 33.5 -75.5t90.5 -27.5zM549 363h317q-7 73 -48.5 114.5 t-104.5 41.5q-62 0 -106.5 -41.5t-57.5 -114.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 622,
    d: "M337 -12q-80 0 -143.5 38.5t-100 108.5t-36.5 165q0 96 36.5 166t100 108t143.5 38q63 0 115.5 -23.5t89 -70t50.5 -117.5h-112q-14 59 -52.5 86t-90.5 27q-77 0 -124.5 -58t-47.5 -156q0 -97 47.5 -155.5t124.5 -58.5q55 0 94.5 29t54.5 94h109q-13 -74 -50 -123 t-90 -73.5t-118 -24.5zM221 -268v76h129v28q0 37 -27 51.5t-71 19.5l63 123h76l-45 -89q41 -8 69.5 -32.5t28.5 -82.5q0 -40 -23.5 -67t-68.5 -27h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 650,
    d: "M339 -12q-81 0 -145 38.5t-100.5 109t-36.5 166.5q0 95 36 164.5t98 107.5t142 38q75 0 133.5 -34t92.5 -98t34 -151v-48h-432q6 -91 54 -145t123 -54q54 0 92 27t51 74h110q-12 -61 -48 -104.5t-88 -67t-116 -23.5zM166 363h322q-7 74 -49 115t-107 41q-64 0 -108 -41.5 t-58 -114.5zM314 679l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 650,
    d: "M339 -12q-81 0 -145 38.5t-100.5 109t-36.5 166.5q0 95 36 164.5t98 107.5t142 38q75 0 133.5 -34t92.5 -98t34 -151v-48h-432q6 -91 54 -145t123 -54q54 0 92 27t51 74h110q-12 -61 -48 -104.5t-88 -67t-116 -23.5zM166 363h322q-7 74 -49 115t-107 41q-64 0 -108 -41.5 t-58 -114.5zM254 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 650,
    d: "M339 -12q-81 0 -145 38.5t-100.5 109t-36.5 166.5q0 95 36 164.5t98 107.5t142 38q75 0 133.5 -34t92.5 -98t34 -151v-48h-432q6 -91 54 -145t123 -54q54 0 92 27t51 74h110q-12 -61 -48 -104.5t-88 -67t-116 -23.5zM166 363h322q-7 74 -49 115t-107 41q-64 0 -108 -41.5 t-58 -114.5zM133 679v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 650,
    d: "M339 -12q-81 0 -145 38.5t-100.5 109t-36.5 166.5q0 95 36 164.5t98 107.5t142 38q75 0 133.5 -34t92.5 -98t34 -151v-48h-432q6 -91 54 -145t123 -54q54 0 92 27t51 74h110q-12 -61 -48 -104.5t-88 -67t-116 -23.5zM166 363h322q-7 74 -49 115t-107 41q-64 0 -108 -41.5 t-58 -114.5zM446 684q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM204 684q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 296,
    d: "M94 0v600h108v-600h-108zM137 679l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 296,
    d: "M94 0v600h108v-600h-108zM77 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 296,
    d: "M94 0v600h108v-600h-108zM-44 679v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 296,
    d: "M94 0v600h108v-600h-108zM232 685q-25 0 -41 18.5t-16 46.5q0 29 16 47t41 18q26 0 42 -18t16 -47q0 -28 -16 -46.5t-42 -18.5zM64 685q-26 0 -42 18.5t-16 46.5q0 29 16 47t42 18q25 0 41 -18t16 -47q0 -28 -16 -46.5t-41 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 680,
    d: "M341 -12q-84 0 -148 37.5t-100 104.5t-36 154q0 88 35 155.5t96.5 105.5t141.5 38q97 0 159 -69h6q-23 45 -66 91t-99 91l-166 -89l-31 58l138 74q-37 27 -78 51.5t-86 45.5v4h154q51 -23 97 -54l126 68l31 -58l-100 -55q98 -84 156 -197.5t58 -232.5q0 -97 -36 -169.5 t-100.5 -113t-151.5 -40.5zM338 82q56 0 97.5 27.5t64.5 76.5t23 114q0 89 -44 140t-122 51q-57 0 -100.5 -27t-68.5 -75t-25 -110q0 -58 22.5 -102.5t62 -69.5t90.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 694,
    d: "M91 0v600h107v-97h4q26 52 73 80t111 28q65 0 115 -31.5t78 -86.5t28 -126v-367h-108v348q0 77 -39.5 121t-110.5 44t-110.5 -44t-39.5 -121v-348h-108zM143 677q4 72 36 111.5t85 39.5q34 0 63.5 -17t56 -34t50.5 -17q46 0 59 68h62q-5 -71 -37 -111t-85 -40 q-32 0 -61.5 17t-56 34t-51.5 17t-39 -16.5t-20 -51.5h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 680,
    d: "M340 -12q-81 0 -145 38.5t-101 108.5t-37 165q0 96 37 166t101 108t145 38q83 0 147 -38t100 -108t36 -166q0 -95 -36.5 -165.5t-100.5 -108.5t-146 -38zM340 86q80 0 127.5 58.5t47.5 155.5q0 98 -47.5 156t-127.5 58q-79 0 -127 -58t-48 -156q0 -97 48 -155.5 t127 -58.5zM329 679l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 680,
    d: "M340 -12q-81 0 -145 38.5t-101 108.5t-37 165q0 96 37 166t101 108t145 38q83 0 147 -38t100 -108t36 -166q0 -95 -36.5 -165.5t-100.5 -108.5t-146 -38zM340 86q80 0 127.5 58.5t47.5 155.5q0 98 -47.5 156t-127.5 58q-79 0 -127 -58t-48 -156q0 -97 48 -155.5 t127 -58.5zM269 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 680,
    d: "M340 -12q-81 0 -145 38.5t-101 108.5t-37 165q0 96 37 166t101 108t145 38q83 0 147 -38t100 -108t36 -166q0 -95 -36.5 -165.5t-100.5 -108.5t-146 -38zM340 86q80 0 127.5 58.5t47.5 155.5q0 98 -47.5 156t-127.5 58q-79 0 -127 -58t-48 -156q0 -97 48 -155.5 t127 -58.5zM148 679v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 680,
    d: "M340 -12q-81 0 -145 38.5t-101 108.5t-37 165q0 96 37 166t101 108t145 38q83 0 147 -38t100 -108t36 -166q0 -95 -36.5 -165.5t-100.5 -108.5t-146 -38zM340 86q80 0 127.5 58.5t47.5 155.5q0 98 -47.5 156t-127.5 58q-79 0 -127 -58t-48 -156q0 -97 48 -155.5 t127 -58.5zM134 677q4 72 36 111.5t85 39.5q34 0 63.5 -17t56 -34t50.5 -17q46 0 59 68h62q-5 -71 -37 -111t-85 -40q-32 0 -61.5 17t-56 34t-51.5 17t-39 -16.5t-20 -51.5h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 680,
    d: "M340 -12q-81 0 -145 38.5t-101 108.5t-37 165q0 96 37 166t101 108t145 38q83 0 147 -38t100 -108t36 -166q0 -95 -36.5 -165.5t-100.5 -108.5t-146 -38zM340 86q80 0 127.5 58.5t47.5 155.5q0 98 -47.5 156t-127.5 58q-79 0 -127 -58t-48 -156q0 -97 48 -155.5 t127 -58.5zM461 684q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM219 684q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    d: "M72 359v92h516v-92h-516zM330 134q-30 0 -51.5 21.5t-21.5 51.5t21.5 51t51.5 21t51.5 -21t21.5 -51t-21.5 -51.5t-51.5 -21.5zM330 530q-30 0 -51.5 21.5t-21.5 51.5t21.5 51.5t51.5 21.5t51.5 -21.5t21.5 -51.5t-21.5 -51.5t-51.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 680,
    d: "M141 -36l-61 41l53 73q-36 40 -56 96.5t-20 125.5q0 96 37 166t101 108t145 38q87 0 152 -42l45 63l62 -40l-51 -70q36 -40 55.5 -96.5t19.5 -126.5q0 -95 -36.5 -165.5t-100.5 -108.5t-146 -38q-86 0 -151 42zM197 159l240 331q-41 28 -97 28q-81 0 -130 -59t-49 -159 q0 -83 36 -141zM340 82q83 0 131 59.5t48 158.5q0 83 -35 139l-239 -327q42 -30 95 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 694,
    d: "M306 -11q-65 0 -114.5 30t-77 84t-27.5 124v373h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -73 -85.5t-113 -29.5zM336 679l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 694,
    d: "M306 -11q-65 0 -114.5 30t-77 84t-27.5 124v373h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -73 -85.5t-113 -29.5zM276 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 694,
    d: "M306 -11q-65 0 -114.5 30t-77 84t-27.5 124v373h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -73 -85.5t-113 -29.5zM155 679v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 694,
    d: "M306 -11q-65 0 -114.5 30t-77 84t-27.5 124v373h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -73 -85.5t-113 -29.5zM468 684q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5 t-19.5 -46.5t-46.5 -19.5zM226 684q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 596,
    d: "M66 -240v86h136l55 151l-251 603h112l191 -469h4l168 469h109l-226 -600l-53 -141q-18 -47 -38.5 -73t-68.5 -26h-138zM227 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 692,
    d: "M91 -240v1080h108v-337h4q51 109 183 109q75 0 131 -39t87 -109t31 -164q0 -93 -31 -163.5t-87 -109.5t-131 -39q-132 0 -183 109h-4v-337h-108zM357 84q78 0 124 59t46 157t-46 157t-124 59q-75 0 -116.5 -47.5t-41.5 -124.5v-88q0 -77 41.5 -123.5t116.5 -48.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 596,
    d: "M66 -240v86h136l55 151l-251 603h112l191 -469h4l168 469h109l-226 -600l-53 -141q-18 -47 -38.5 -73t-68.5 -26h-138zM419 684q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM177 684q-27 0 -46.5 19.5 t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 762,
    d: "M6 0l315 810h123l312 -810h-115l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4zM192 921v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 624,
    d: "M246 -11q-89 0 -144.5 50.5t-55.5 130.5q0 85 55.5 132.5t157.5 47.5h175v30q0 66 -35.5 102.5t-99.5 36.5q-53 0 -87.5 -24.5t-45.5 -69.5h-110q15 87 81 137t164 50q111 0 173.5 -60t62.5 -169v-383h-102v104h-4q-23 -53 -73 -84t-112 -31zM268 79q47 0 84.5 22 t59.5 59.5t22 83.5v24h-168q-58 0 -88.5 -24.5t-30.5 -68.5t33 -70t88 -26zM113 711v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 762,
    d: "M6 0l315 810h123l312 -810h-115l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4zM382 886q-53 0 -91.5 19t-60.5 54.5t-26 82.5h74q6 -33 30.5 -53t73.5 -20t73.5 20t30.5 53h74q-4 -47 -26 -82.5t-60.5 -54.5t-91.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 624,
    d: "M246 -11q-89 0 -144.5 50.5t-55.5 130.5q0 85 55.5 132.5t157.5 47.5h175v30q0 66 -35.5 102.5t-99.5 36.5q-53 0 -87.5 -24.5t-45.5 -69.5h-110q15 87 81 137t164 50q111 0 173.5 -60t62.5 -169v-383h-102v104h-4q-23 -53 -73 -84t-112 -31zM268 79q47 0 84.5 22 t59.5 59.5t22 83.5v24h-168q-58 0 -88.5 -24.5t-30.5 -68.5t33 -70t88 -26zM302 676q-53 0 -91.5 19t-60.5 54.5t-26 82.5h74q6 -33 30.5 -53t73.5 -20t73.5 20t30.5 53h74q-4 -47 -26 -82.5t-60.5 -54.5t-91.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 762,
    d: "M6 0l315 810h123l312 -810h-115l-89 242h-343l-91 -242h-112zM245 340h272l-133 360h-4zM673 -240q-47 0 -69.5 24t-22.5 68q0 51 35 96.5t77 71.5l63 -20q-40 -32 -60.5 -64t-20.5 -75v-22h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 624,
    d: "M246 -11q-89 0 -144.5 50.5t-55.5 130.5q0 85 55.5 132.5t157.5 47.5h175v30q0 66 -35.5 102.5t-99.5 36.5q-53 0 -87.5 -24.5t-45.5 -69.5h-110q15 87 81 137t164 50q111 0 173.5 -60t62.5 -169v-383h-102v104h-4q-23 -53 -73 -84t-112 -31zM268 79q47 0 84.5 22 t59.5 59.5t22 83.5v24h-168q-58 0 -88.5 -24.5t-30.5 -68.5t33 -70t88 -26zM454 -240q-47 0 -69.5 24t-22.5 68q0 51 35 96.5t77 71.5l63 -20q-40 -32 -60.5 -64t-20.5 -75v-22h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 792,
    d: "M434 -13q-110 0 -193.5 52.5t-130 146.5t-46.5 219q0 124 46.5 218t130 146.5t193.5 52.5q86 0 154 -31.5t111.5 -90t56.5 -139.5h-115q-12 73 -67.5 117t-139.5 44q-78 0 -136.5 -39.5t-90 -110.5t-31.5 -167t31.5 -167t90 -110.5t136.5 -39.5q84 0 139.5 44t67.5 116 h115q-13 -80 -56.5 -138.5t-111.5 -90.5t-154 -32zM363 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 622,
    d: "M337 -12q-80 0 -143.5 38.5t-100 108.5t-36.5 165q0 96 36.5 166t100 108t143.5 38q63 0 115.5 -23.5t89 -70t50.5 -117.5h-112q-14 59 -52.5 86t-90.5 27q-77 0 -124.5 -58t-47.5 -156q0 -97 47.5 -155.5t124.5 -58.5q55 0 94.5 29t54.5 94h109q-13 -74 -50 -123 t-90 -73.5t-118 -24.5zM266 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 792,
    d: "M434 -13q-110 0 -193.5 52.5t-130 146.5t-46.5 219q0 124 46.5 218t130 146.5t193.5 52.5q86 0 154 -31.5t111.5 -90t56.5 -139.5h-115q-12 73 -67.5 117t-139.5 44q-78 0 -136.5 -39.5t-90 -110.5t-31.5 -167t31.5 -167t90 -110.5t136.5 -39.5q84 0 139.5 44t67.5 116 h115q-13 -80 -56.5 -138.5t-111.5 -90.5t-154 -32zM434 892q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 622,
    d: "M337 -12q-80 0 -143.5 38.5t-100 108.5t-36.5 165q0 96 36.5 166t100 108t143.5 38q63 0 115.5 -23.5t89 -70t50.5 -117.5h-112q-14 59 -52.5 86t-90.5 27q-77 0 -124.5 -58t-47.5 -156q0 -97 47.5 -155.5t124.5 -58.5q55 0 94.5 29t54.5 94h109q-13 -74 -50 -123 t-90 -73.5t-118 -24.5zM337 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 792,
    d: "M434 -13q-110 0 -193.5 52.5t-130 146.5t-46.5 219q0 124 46.5 218t130 146.5t193.5 52.5q86 0 154 -31.5t111.5 -90t56.5 -139.5h-115q-12 73 -67.5 117t-139.5 44q-78 0 -136.5 -39.5t-90 -110.5t-31.5 -167t31.5 -167t90 -110.5t136.5 -39.5q84 0 139.5 44t67.5 116 h115q-13 -80 -56.5 -138.5t-111.5 -90.5t-154 -32zM379 889l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 622,
    d: "M337 -12q-80 0 -143.5 38.5t-100 108.5t-36.5 165q0 96 36.5 166t100 108t143.5 38q63 0 115.5 -23.5t89 -70t50.5 -117.5h-112q-14 59 -52.5 86t-90.5 27q-77 0 -124.5 -58t-47.5 -156q0 -97 47.5 -155.5t124.5 -58.5q55 0 94.5 29t54.5 94h109q-13 -74 -50 -123 t-90 -73.5t-118 -24.5zM282 679l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 816,
    d: "M109 0v810h254q121 0 211 -49t139 -140t49 -216q0 -124 -49.5 -215t-139 -140.5t-210.5 -49.5h-254zM220 98h143q93 0 157 38.5t97 107.5t33 161q0 139 -73.5 223t-213.5 84h-143v-614zM325 889l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 796,
    d: "M306 -12q-75 0 -131 39t-87 109.5t-31 163.5q0 94 31 164t87 109t131 39q132 0 183 -109h4v337h108v-840h-107v98h-4q-52 -110 -184 -110zM335 84q75 0 116.5 47.5t41.5 124.5v88q0 77 -41.5 124.5t-116.5 47.5q-77 0 -123.5 -59t-46.5 -157t46.5 -157t123.5 -59z M656 566l64 274h106v-4l-93 -270h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 846,
    d: "M139 0v375h-109v90h109v345h254q121 0 211 -49t139 -140t49 -216q0 -124 -49.5 -215t-139 -140.5t-210.5 -49.5h-254zM250 98h143q93 0 157 38.5t97 107.5t33 161q0 139 -73.5 223t-213.5 84h-143v-247h224v-90h-224v-277z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 692,
    d: "M306 -12q-75 0 -131 38.5t-87 105.5t-31 153t31 153t87 105.5t131 38.5q132 0 183 -109h4v209h-235v76h235v82h108v-82h79v-76h-79v-682h-107v98h-4q-52 -110 -184 -110zM335 84q75 0 116.5 46.5t41.5 115.5v78q0 69 -41.5 115.5t-116.5 46.5q-52 0 -90 -26t-59 -71.5 t-21 -103.5q0 -57 21 -103t59 -72t90 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 684,
    d: "M624 0h-515v810h515v-98h-404v-244h382v-96h-382v-274h404v-98zM177 921v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 650,
    d: "M339 -12q-81 0 -145 38.5t-100.5 109t-36.5 166.5q0 95 36 164.5t98 107.5t142 38q75 0 133.5 -34t92.5 -98t34 -151v-48h-432q6 -91 54 -145t123 -54q54 0 92 27t51 74h110q-12 -61 -48 -104.5t-88 -67t-116 -23.5zM166 363h322q-7 74 -49 115t-107 41q-64 0 -108 -41.5 t-58 -114.5zM135 711v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 684,
    d: "M624 0h-515v810h515v-98h-404v-244h382v-96h-382v-274h404v-98zM367 892q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 650,
    d: "M339 -12q-81 0 -145 38.5t-100.5 109t-36.5 166.5q0 95 36 164.5t98 107.5t142 38q75 0 133.5 -34t92.5 -98t34 -151v-48h-432q6 -91 54 -145t123 -54q54 0 92 27t51 74h110q-12 -61 -48 -104.5t-88 -67t-116 -23.5zM166 363h322q-7 74 -49 115t-107 41q-64 0 -108 -41.5 t-58 -114.5zM325 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 684,
    d: "M624 0h-515v810h515v-98h-404v-244h382v-96h-382v-274h404v-98zM541 -240q-47 0 -69.5 24t-22.5 68q0 51 35 96.5t77 71.5l63 -20q-40 -32 -60.5 -64t-20.5 -75v-22h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 650,
    d: "M339 -12q-81 0 -145 38.5t-100.5 109t-36.5 166.5q0 95 36 164.5t98 107.5t142 38q75 0 133.5 -34t92.5 -98t34 -151v-48h-432q6 -91 54 -145t123 -54q54 0 92 27t51 74h110q-12 -61 -48 -104.5t-88 -67t-116 -23.5zM166 363h322q-7 74 -49 115t-107 41q-64 0 -108 -41.5 t-58 -114.5zM398 -240q-47 0 -69.5 24t-22.5 68q0 53 35 100t77 75h63q-40 -39 -60.5 -76t-20.5 -87v-25h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 684,
    d: "M624 0h-515v810h515v-98h-404v-244h382v-96h-382v-274h404v-98zM312 889l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 650,
    d: "M339 -12q-81 0 -145 38.5t-100.5 109t-36.5 166.5q0 95 36 164.5t98 107.5t142 38q75 0 133.5 -34t92.5 -98t34 -151v-48h-432q6 -91 54 -145t123 -54q54 0 92 27t51 74h110q-12 -61 -48 -104.5t-88 -67t-116 -23.5zM166 363h322q-7 74 -49 115t-107 41q-64 0 -108 -41.5 t-58 -114.5zM270 679l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 844,
    d: "M423 -12q-105 0 -186 53t-127 147.5t-46 216.5q0 124 48 218t133.5 146.5t195.5 52.5q86 0 153.5 -32t111 -90t56.5 -139h-115q-12 74 -67 117.5t-139 43.5q-79 0 -139 -39.5t-93 -111t-33 -167.5q0 -93 33 -165.5t92 -114.5t136 -42q63 0 111.5 24.5t77 66t28.5 92.5v51 h-231v93h242q47 0 72 -25t25 -72v-312h-104v118h-4q-23 -57 -84 -93.5t-147 -36.5zM418 886q-53 0 -91.5 19t-60.5 54.5t-26 82.5h74q6 -33 30.5 -53t73.5 -20t73.5 20t30.5 53h74q-4 -47 -26 -82.5t-60.5 -54.5t-91.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 694,
    d: "M327 -252q-111 0 -185 53.5t-86 142.5h115q10 -48 51 -75t103 -27q80 0 125.5 46t45.5 125v97h-4q-22 -53 -68.5 -81.5t-109.5 -28.5q-76 0 -133.5 38.5t-89.5 107.5t-32 160t32 160t89.5 107.5t133.5 38.5q63 0 109.5 -28.5t68.5 -80.5h4v97h107v-592q0 -120 -74.5 -190 t-201.5 -70zM340 98q71 0 113 46t42 122v80q0 76 -42.5 122t-112.5 46q-79 0 -126 -56.5t-47 -151.5t47 -151.5t126 -56.5zM346 676q-53 0 -91.5 19t-60.5 54.5t-26 82.5h74q6 -33 30.5 -53t73.5 -20t73.5 20t30.5 53h74q-4 -47 -26 -82.5t-60.5 -54.5t-91.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 844,
    d: "M423 -12q-105 0 -186 53t-127 147.5t-46 216.5q0 124 48 218t133.5 146.5t195.5 52.5q86 0 153.5 -32t111 -90t56.5 -139h-115q-12 74 -67 117.5t-139 43.5q-79 0 -139 -39.5t-93 -111t-33 -167.5q0 -93 33 -165.5t92 -114.5t136 -42q63 0 111.5 24.5t77 66t28.5 92.5v51 h-231v93h242q47 0 72 -25t25 -72v-312h-104v118h-4q-23 -57 -84 -93.5t-147 -36.5zM419 892q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 694,
    d: "M327 -252q-111 0 -185 53.5t-86 142.5h115q10 -48 51 -75t103 -27q80 0 125.5 46t45.5 125v97h-4q-22 -53 -68.5 -81.5t-109.5 -28.5q-76 0 -133.5 38.5t-89.5 107.5t-32 160t32 160t89.5 107.5t133.5 38.5q63 0 109.5 -28.5t68.5 -80.5h4v97h107v-592q0 -120 -74.5 -190 t-201.5 -70zM340 98q71 0 113 46t42 122v80q0 76 -42.5 122t-112.5 46q-79 0 -126 -56.5t-47 -151.5t47 -151.5t126 -56.5zM347 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0122",
    unicode: "\u0122",
    horizAdvX: 844,
    d: "M423 -12q-105 0 -186 53t-127 147.5t-46 216.5q0 124 48 218t133.5 146.5t195.5 52.5q86 0 153.5 -32t111 -90t56.5 -139h-115q-12 74 -67 117.5t-139 43.5q-79 0 -139 -39.5t-93 -111t-33 -167.5q0 -93 33 -165.5t92 -114.5t136 -42q63 0 111.5 24.5t77 66t28.5 92.5v51 h-231v93h242q47 0 72 -25t25 -72v-312h-104v118h-4q-23 -57 -84 -93.5t-147 -36.5zM343 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0123",
    unicode: "\u0123",
    horizAdvX: 694,
    d: "M327 -252q-111 0 -185 53.5t-86 142.5h115q10 -48 51 -75t103 -27q80 0 125.5 46t45.5 125v97h-4q-22 -53 -68.5 -81.5t-109.5 -28.5q-76 0 -133.5 38.5t-89.5 107.5t-32 160t32 160t89.5 107.5t133.5 38.5q63 0 109.5 -28.5t68.5 -80.5h4v97h107v-592q0 -120 -74.5 -190 t-201.5 -70zM340 98q71 0 113 46t42 122v80q0 76 -42.5 122t-112.5 46q-79 0 -126 -56.5t-47 -151.5t47 -151.5t126 -56.5zM292 694v135q0 51 27 79t79 28h36v-66h-28q-22 0 -34.5 -12t-12.5 -35v-20h46v-109h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 914,
    d: "M139 0v622h-109v76h109v112h111v-112h414v112h111v-112h109v-76h-109v-622h-111v341h-414v-341h-111zM250 439h414v183h-414v-183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 694,
    d: "M91 0v682h-79v76h79v82h108v-82h235v-76h-235v-200h4q26 46 73 73t110 27q65 0 115 -31t78 -86t28 -128v-337h-108v321q0 78 -39.5 121t-110.5 43t-110.5 -43t-39.5 -121v-321h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 330,
    d: "M110 0v810h110v-810h-110zM-25 921v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 296,
    d: "M94 0v600h108v-600h-108zM18 711v78h260v-78h-260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 330,
    d: "M110 0v810h110v-810h-110zM137 -240q-47 0 -69.5 24t-22.5 68q0 51 35 96.5t77 71.5l63 -20q-40 -32 -60.5 -64t-20.5 -75v-22h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 296,
    d: "M94 0v600h108v-600h-108zM148 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20zM119 -240q-47 0 -69.5 24t-22.5 68q0 51 35 96.5t77 71.5l63 -20q-40 -32 -60.5 -64t-20.5 -75v-22h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 330,
    d: "M110 0v810h110v-810h-110zM165 892q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 296,
    d: "M94 0v600h108v-600h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 780,
    d: "M110 0v810h110v-810h-110zM360 0v98h200v712h110v-709q0 -51 -26.5 -76t-74.5 -25h-209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 586,
    d: "M94 0v600h108v-600h-108zM148 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20zM277 -240v86h115v754h108v-739q0 -51 -26.5 -76t-73.5 -25h-123zM446 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0136",
    unicode: "\u0136",
    horizAdvX: 752,
    d: "M109 0v810h111v-386h4l360 386h136l-334 -348l345 -462h-134l-291 387l-86 -76v-311h-111zM316 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0137",
    unicode: "\u0137",
    horizAdvX: 632,
    d: "M91 0v840h108v-510h4l260 270h130l-246 -251l269 -349h-131l-213 281l-73 -65v-216h-108zM229 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 646,
    d: "M109 0v810h111v-712h396v-98h-507zM93 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 296,
    d: "M94 0v840h108v-840h-108zM77 919v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013B",
    unicode: "\u013B",
    horizAdvX: 646,
    d: "M109 0v810h111v-712h396v-98h-507zM276 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C",
    unicode: "\u013C",
    horizAdvX: 296,
    d: "M94 0v840h108v-840h-108zM61 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 646,
    d: "M109 0v810h111v-712h396v-98h-507zM275 536l64 274h106v-4l-93 -270h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 400,
    d: "M94 0v840h108v-840h-108zM259 566l64 274h106v-4l-93 -270h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 676,
    d: "M139 0v310l-109 -59v98l109 58v403h111v-343l224 121v-97l-224 -121v-271h396v-99h-507z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 356,
    d: "M124 0v317l-94 -51v89l94 50v435h108v-377l94 51v-89l-94 -50v-375h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 882,
    d: "M773 0h-124l-433 647h-4v-647h-103v810h122l435 -650h4v650h103v-810zM378 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 694,
    d: "M91 0v600h107v-97h4q26 52 73 80t111 28q65 0 115 -31.5t78 -86.5t28 -126v-367h-108v348q0 77 -39.5 121t-110.5 44t-110.5 -44t-39.5 -121v-348h-108zM278 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0145",
    unicode: "\u0145",
    horizAdvX: 882,
    d: "M773 0h-124l-433 647h-4v-647h-103v810h122l435 -650h4v650h103v-810zM346 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0146",
    unicode: "\u0146",
    horizAdvX: 694,
    d: "M91 0v600h107v-97h4q26 52 73 80t111 28q65 0 115 -31.5t78 -86.5t28 -126v-367h-108v348q0 77 -39.5 121t-110.5 44t-110.5 -44t-39.5 -121v-348h-108zM262 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 882,
    d: "M773 0h-124l-433 647h-4v-647h-103v810h122l435 -650h4v650h103v-810zM394 889l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 694,
    d: "M91 0v600h107v-97h4q26 52 73 80t111 28q65 0 115 -31.5t78 -86.5t28 -126v-367h-108v348q0 77 -39.5 121t-110.5 44t-110.5 -44t-39.5 -121v-348h-108zM294 679l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 882,
    d: "M524 -186v94h146v92l-454 647h-4v-647h-103v810h122l435 -620h4v620h103v-895q0 -51 -26.5 -76t-74.5 -25h-148z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 694,
    d: "M371 -240v86h128v502q0 77 -39.5 121t-110.5 44t-110.5 -44t-39.5 -121v-348h-108v600h107v-97h4q26 52 73 80t111 28q65 0 115 -31.5t78 -86.5t28 -126v-506q0 -51 -26.5 -76t-74.5 -25h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 870,
    d: "M435 -12q-107 0 -191 51.5t-132 145t-48 220.5q0 128 48 221.5t132 144.5t191 51q108 0 192 -50.5t131.5 -144t47.5 -222.5q0 -127 -48 -221t-131.5 -145t-191.5 -51zM435 88q79 0 137.5 39.5t90 111t31.5 166.5q0 96 -31.5 167.5t-90 110.5t-137.5 39t-137 -39 t-90 -110.5t-32 -167.5q0 -95 32 -166.5t90 -111t137 -39.5zM245 921v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 680,
    d: "M340 -12q-81 0 -145 38.5t-101 108.5t-37 165q0 96 37 166t101 108t145 38q83 0 147 -38t100 -108t36 -166q0 -95 -36.5 -165.5t-100.5 -108.5t-146 -38zM340 86q80 0 127.5 58.5t47.5 155.5q0 98 -47.5 156t-127.5 58q-79 0 -127 -58t-48 -156q0 -97 48 -155.5 t127 -58.5zM150 711v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 870,
    d: "M435 -12q-107 0 -191 51.5t-132 145t-48 220.5q0 128 48 221.5t132 144.5t191 51q108 0 192 -50.5t131.5 -144t47.5 -222.5q0 -127 -48 -221t-131.5 -145t-191.5 -51zM435 88q79 0 137.5 39.5t90 111t31.5 166.5q0 96 -31.5 167.5t-90 110.5t-137.5 39t-137 -39 t-90 -110.5t-32 -167.5q0 -95 32 -166.5t90 -111t137 -39.5zM472 889v4l98 176h118v-4l-143 -176h-73zM264 889v4l96 176h120v-4l-145 -176h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 680,
    d: "M340 -12q-81 0 -145 38.5t-101 108.5t-37 165q0 96 37 166t101 108t145 38q83 0 147 -38t100 -108t36 -166q0 -95 -36.5 -165.5t-100.5 -108.5t-146 -38zM340 86q80 0 127.5 58.5t47.5 155.5q0 98 -47.5 156t-127.5 58q-79 0 -127 -58t-48 -156q0 -97 48 -155.5 t127 -58.5zM377 679v4l98 176h118v-4l-143 -176h-73zM169 679v4l96 176h120v-4l-145 -176h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1228,
    d: "M423 -12q-105 0 -186 53t-127 147.5t-46 216.5q0 123 46 216.5t127 147t186 53.5q86 0 146.5 -36.5t83.5 -93.5h4v118h511v-98h-404v-244h382v-96h-382v-274h404v-98h-511v118h-4q-23 -57 -83.5 -93.5t-146.5 -36.5zM437 82q62 0 111 24.5t77 66t28 92.5v279 q0 52 -28 93.5t-77 65.5t-111 24q-77 0 -136 -41.5t-92 -114t-33 -166.5q0 -93 33 -166t92 -115t136 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1102,
    d: "M338 -12q-80 0 -144 38.5t-100.5 108.5t-36.5 165q0 96 36.5 166t100.5 108t144 38q72 0 131 -31t94 -93h4q34 61 91 92.5t127 31.5q74 0 132 -34t92 -98t34 -151v-48h-428q5 -91 53 -145t122 -54q52 0 90 27t51 74h111q-13 -61 -49 -104.5t-87.5 -67t-114.5 -23.5 q-71 0 -130 33t-95 95h-4q-34 -62 -93 -95t-131 -33zM338 86q79 0 126 58.5t47 155.5q0 98 -47 156t-126 58q-78 0 -125.5 -58t-47.5 -156q0 -97 47.5 -155.5t125.5 -58.5zM620 363h318q-7 74 -49 115t-105 41q-62 0 -106.5 -41.5t-57.5 -114.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 796,
    d: "M109 0v810h346q74 0 129.5 -26t87 -75.5t31.5 -120.5q0 -54 -23 -98.5t-74 -71.5v-4q47 0 72 -25.5t25 -72.5v-316h-110v332h-373v-332h-111zM220 427h224q67 0 108.5 37.5t41.5 105.5q0 69 -41.5 106t-108.5 37h-224v-286zM297 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 464,
    d: "M102 0v600h103v-120h4q20 56 65.5 90.5t111.5 34.5h44v-96h-50q-83 0 -126.5 -53t-43.5 -143v-313h-108zM195 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0156",
    unicode: "\u0156",
    horizAdvX: 796,
    d: "M109 0v810h346q74 0 129.5 -26t87 -75.5t31.5 -120.5q0 -54 -23 -98.5t-74 -71.5v-4q47 0 72 -25.5t25 -72.5v-316h-110v332h-373v-332h-111zM220 427h224q67 0 108.5 37.5t41.5 105.5q0 69 -41.5 106t-108.5 37h-224v-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0157",
    unicode: "\u0157",
    horizAdvX: 464,
    d: "M102 0v600h103v-120h4q20 56 65.5 90.5t111.5 34.5h44v-96h-50q-83 0 -126.5 -53t-43.5 -143v-313h-108zM69 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 796,
    d: "M109 0v810h346q74 0 129.5 -26t87 -75.5t31.5 -120.5q0 -54 -23 -98.5t-74 -71.5v-4q47 0 72 -25.5t25 -72.5v-316h-110v332h-373v-332h-111zM220 427h224q67 0 108.5 37.5t41.5 105.5q0 69 -41.5 106t-108.5 37h-224v-286zM313 889l-137 176v4h78l113 -102l113 102h80 v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 464,
    d: "M102 0v600h103v-120h4q20 56 65.5 90.5t111.5 34.5h44v-96h-50q-83 0 -126.5 -53t-43.5 -143v-313h-108zM211 679l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 724,
    d: "M374 -12q-94 0 -165 32.5t-111.5 90t-45.5 134.5h116q9 -78 64.5 -119t145.5 -41q85 0 131 35.5t46 99.5q0 51 -32.5 84.5t-101.5 47.5l-128 29q-101 22 -154 76t-53 137q0 67 33.5 118.5t95 80.5t144.5 29q85 0 149 -30.5t102.5 -85t46.5 -128.5h-116q-13 73 -62 110.5 t-126 37.5q-72 0 -115.5 -33t-43.5 -90q0 -45 30.5 -76.5t99.5 -46.5l133 -30q103 -23 154.5 -78t51.5 -143q0 -110 -76.5 -175.5t-212.5 -65.5zM285 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 568,
    d: "M297 -12q-108 0 -175.5 53.5t-73.5 143.5h106q7 -52 45 -79.5t102 -27.5q59 0 90 23t31 65q0 66 -91 85l-99 22q-162 34 -162 160q0 80 60 129.5t157 49.5q96 0 158.5 -50.5t70.5 -136.5h-104q-10 47 -43.5 72.5t-86.5 25.5q-51 0 -81 -22t-30 -60q0 -30 21 -48.5 t67 -28.5l100 -21q82 -18 122.5 -59.5t40.5 -108.5q0 -86 -60 -136.5t-165 -50.5zM213 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 724,
    d: "M374 -12q-94 0 -165 32.5t-111.5 90t-45.5 134.5h116q9 -78 64.5 -119t145.5 -41q85 0 131 35.5t46 99.5q0 51 -32.5 84.5t-101.5 47.5l-128 29q-101 22 -154 76t-53 137q0 67 33.5 118.5t95 80.5t144.5 29q85 0 149 -30.5t102.5 -85t46.5 -128.5h-116q-13 73 -62 110.5 t-126 37.5q-72 0 -115.5 -33t-43.5 -90q0 -45 30.5 -76.5t99.5 -46.5l133 -30q103 -23 154.5 -78t51.5 -143q0 -110 -76.5 -175.5t-212.5 -65.5zM260 -268v76h129v28q0 37 -27 51.5t-71 19.5l63 123h76l-45 -89q41 -8 69.5 -32.5t28.5 -82.5q0 -40 -23.5 -67t-68.5 -27h-131 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 568,
    d: "M297 -12q-108 0 -175.5 53.5t-73.5 143.5h106q7 -52 45 -79.5t102 -27.5q59 0 90 23t31 65q0 66 -91 85l-99 22q-162 34 -162 160q0 80 60 129.5t157 49.5q96 0 158.5 -50.5t70.5 -136.5h-104q-10 47 -43.5 72.5t-86.5 25.5q-51 0 -81 -22t-30 -60q0 -30 21 -48.5 t67 -28.5l100 -21q82 -18 122.5 -59.5t40.5 -108.5q0 -86 -60 -136.5t-165 -50.5zM172 -268v76h129v28q0 37 -27 51.5t-71 19.5l63 123h76l-45 -89q41 -8 69.5 -32.5t28.5 -82.5q0 -40 -23.5 -67t-68.5 -27h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 724,
    d: "M374 -12q-94 0 -165 32.5t-111.5 90t-45.5 134.5h116q9 -78 64.5 -119t145.5 -41q85 0 131 35.5t46 99.5q0 51 -32.5 84.5t-101.5 47.5l-128 29q-101 22 -154 76t-53 137q0 67 33.5 118.5t95 80.5t144.5 29q85 0 149 -30.5t102.5 -85t46.5 -128.5h-116q-13 73 -62 110.5 t-126 37.5q-72 0 -115.5 -33t-43.5 -90q0 -45 30.5 -76.5t99.5 -46.5l133 -30q103 -23 154.5 -78t51.5 -143q0 -110 -76.5 -175.5t-212.5 -65.5zM301 889l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 568,
    d: "M297 -12q-108 0 -175.5 53.5t-73.5 143.5h106q7 -52 45 -79.5t102 -27.5q59 0 90 23t31 65q0 66 -91 85l-99 22q-162 34 -162 160q0 80 60 129.5t157 49.5q96 0 158.5 -50.5t70.5 -136.5h-104q-10 47 -43.5 72.5t-86.5 25.5q-51 0 -81 -22t-30 -60q0 -30 21 -48.5 t67 -28.5l100 -21q82 -18 122.5 -59.5t40.5 -108.5q0 -86 -60 -136.5t-165 -50.5zM229 679l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 690,
    d: "M400 0h-110v712h-266v98h642v-98h-266v-712zM290 889l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 414,
    d: "M218 0q-46 0 -72 24.5t-26 73.5v416h-102v86h103v180h106v-180h143v-86h-142v-428h156v-86h-166zM282 686l64 274h106v-4l-93 -270h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 824,
    d: "M409 -12q-98 0 -167.5 36t-106.5 103.5t-37 162.5v520h113v-514q0 -98 51 -151t152 -53q103 0 152 56.5t49 146.5v515h111v-522q0 -90 -36 -157.5t-106.5 -105t-174.5 -37.5zM223 921v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 694,
    d: "M306 -11q-65 0 -114.5 30t-77 84t-27.5 124v373h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -73 -85.5t-113 -29.5zM157 711v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 824,
    d: "M409 -12q-98 0 -167.5 36t-106.5 103.5t-37 162.5v520h113v-514q0 -98 51 -151t152 -53q103 0 152 56.5t49 146.5v515h111v-522q0 -90 -36 -157.5t-106.5 -105t-174.5 -37.5zM412 886q-53 0 -91.5 19t-60.5 54.5t-26 82.5h74q6 -33 30.5 -53t73.5 -20t73.5 20t30.5 53h74 q-4 -47 -26 -82.5t-60.5 -54.5t-91.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 694,
    d: "M306 -11q-65 0 -114.5 30t-77 84t-27.5 124v373h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -73 -85.5t-113 -29.5zM346 676q-53 0 -91.5 19t-60.5 54.5t-26 82.5h74q6 -33 30.5 -53t73.5 -20t73.5 20t30.5 53h74 q-4 -47 -26 -82.5t-60.5 -54.5t-91.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 824,
    d: "M409 -12q-98 0 -167.5 36t-106.5 103.5t-37 162.5v520h113v-514q0 -98 51 -151t152 -53q103 0 152 56.5t49 146.5v515h111v-522q0 -90 -36 -157.5t-106.5 -105t-174.5 -37.5zM413 854q-38 0 -70.5 18.5t-51.5 50t-19 70.5q0 40 19 71t51.5 49.5t70.5 18.5q39 0 71 -18.5 t51 -49.5t19 -71q0 -39 -19 -70.5t-51 -50t-71 -18.5zM413 923q29 0 49.5 20t20.5 50t-20.5 50t-49.5 20t-49.5 -20t-20.5 -50t20.5 -50t49.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 694,
    d: "M306 -11q-65 0 -114.5 30t-77 84t-27.5 124v373h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -73 -85.5t-113 -29.5zM347 674q-34 0 -63 16.5t-46 44.5t-17 63t17 63t46 44.5t63 16.5q35 0 63.5 -16.5t45.5 -44.5 t17 -63t-17 -63t-45.5 -44.5t-63.5 -16.5zM347 737q25 0 43 17t18 44t-18 44t-43 17t-43 -17t-18 -44t18 -44t43 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 824,
    d: "M409 -12q-98 0 -167.5 36t-106.5 103.5t-37 162.5v520h113v-514q0 -98 51 -151t152 -53q103 0 152 56.5t49 146.5v515h111v-522q0 -90 -36 -157.5t-106.5 -105t-174.5 -37.5zM450 889v4l98 176h118v-4l-143 -176h-73zM242 889v4l96 176h120v-4l-145 -176h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 694,
    d: "M306 -11q-65 0 -114.5 30t-77 84t-27.5 124v373h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -73 -85.5t-113 -29.5zM384 679v4l98 176h118v-4l-143 -176h-73zM176 679v4l96 176h120v-4l-145 -176h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 824,
    d: "M409 -12q-98 0 -167.5 36t-106.5 103.5t-37 162.5v520h113v-514q0 -98 51 -151t152 -53q103 0 152 56.5t49 146.5v515h111v-522q0 -90 -36 -157.5t-106.5 -105t-174.5 -37.5zM421 -240q-47 0 -69.5 24t-22.5 68q0 51 35 96.5t77 71.5l63 -20q-40 -32 -60.5 -64t-20.5 -75 v-22h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 694,
    d: "M306 -11q-65 0 -114.5 30t-77 84t-27.5 124v373h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -73 -85.5t-113 -29.5zM520 -240q-47 0 -69.5 24t-22.5 68q0 51 35 96.5t77 71.5l63 -20q-40 -32 -60.5 -64t-20.5 -75 v-22h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1088,
    d: "M244 0l-208 810h117l152 -657h4l176 657h110l185 -657h4l151 657h117l-208 -810h-118l-185 664h-4l-175 -664h-118zM349 889v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 920,
    d: "M190 0l-172 600h110l126 -467h4l147 467h112l147 -467h4l126 467h108l-172 -600h-120l-148 468h-4l-148 -468h-120zM268 679v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 700,
    d: "M295 0v305l-283 505h126l213 -390h4l213 390h120l-283 -503v-307h-110zM160 889v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 596,
    d: "M66 -240v86h136l55 151l-251 603h112l191 -469h4l168 469h109l-226 -600l-53 -141q-18 -47 -38.5 -73t-68.5 -26h-138zM106 679v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 700,
    d: "M295 0v305l-283 505h126l213 -390h4l213 390h120l-283 -503v-307h-110zM473 894q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM231 894q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5 t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 680,
    d: "M50 0v82l432 630h-414v98h550v-82l-432 -630h444v-98h-580zM269 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 560,
    d: "M50 0v74l327 438h-309v88h436v-74l-327 -438h333v-88h-460zM209 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 680,
    d: "M50 0v82l432 630h-414v98h550v-82l-432 -630h444v-98h-580zM340 892q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 560,
    d: "M50 0v74l327 438h-309v88h436v-74l-327 -438h333v-88h-460zM280 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 680,
    d: "M50 0v82l432 630h-414v98h550v-82l-432 -630h444v-98h-580zM285 889l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 560,
    d: "M50 0v74l327 438h-309v88h436v-74l-327 -438h333v-88h-460zM225 679l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    d: "M264 -180v532h-170v86h171v271q0 51 26.5 76t74.5 25h212v-86h-207v-286h195v-86h-194v-532h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 724,
    d: "M374 -12q-94 0 -165 32.5t-111.5 90t-45.5 134.5h116q9 -78 64.5 -119t145.5 -41q85 0 131 35.5t46 99.5q0 51 -32.5 84.5t-101.5 47.5l-128 29q-101 22 -154 76t-53 137q0 67 33.5 118.5t95 80.5t144.5 29q85 0 149 -30.5t102.5 -85t46.5 -128.5h-116q-13 73 -62 110.5 t-126 37.5q-72 0 -115.5 -33t-43.5 -90q0 -45 30.5 -76.5t99.5 -46.5l133 -30q103 -23 154.5 -78t51.5 -143q0 -110 -76.5 -175.5t-212.5 -65.5zM289 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 568,
    d: "M297 -12q-108 0 -175.5 53.5t-73.5 143.5h106q7 -52 45 -79.5t102 -27.5q59 0 90 23t31 65q0 66 -91 85l-99 22q-162 34 -162 160q0 80 60 129.5t157 49.5q96 0 158.5 -50.5t70.5 -136.5h-104q-10 47 -43.5 72.5t-86.5 25.5q-51 0 -81 -22t-30 -60q0 -30 21 -48.5 t67 -28.5l100 -21q82 -18 122.5 -59.5t40.5 -108.5q0 -86 -60 -136.5t-165 -50.5zM201 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 690,
    d: "M400 0h-110v712h-266v98h642v-98h-266v-712zM258 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 408,
    d: "M218 0q-46 0 -72 24.5t-26 73.5v416h-102v86h103v180h106v-180h143v-86h-142v-428h156v-86h-166zM165 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0237",
    unicode: "\u0237",
    horizAdvX: 290,
    d: "M-19 -240v86h115v754h108v-739q0 -51 -26.5 -76t-73.5 -25h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 600,
    d: "M108 679v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 600,
    d: "M245 679l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 600,
    d: "M300 676q-53 0 -91.5 19t-60.5 54.5t-26 82.5h74q6 -33 30.5 -53t73.5 -20t73.5 20t30.5 53h74q-4 -47 -26 -82.5t-60.5 -54.5t-91.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 600,
    d: "M300 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 600,
    d: "M300 674q-34 0 -63 16.5t-46 44.5t-17 63t17 63t46 44.5t63 16.5q35 0 63.5 -16.5t45.5 -44.5t17 -63t-17 -63t-45.5 -44.5t-63.5 -16.5zM300 737q25 0 43 17t18 44t-18 44t-43 17t-43 -17t-18 -44t18 -44t43 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 600,
    d: "M290 -240q-47 0 -69.5 24t-22.5 68q0 51 35 96.5t77 71.5l63 -20q-40 -32 -60.5 -64t-20.5 -75v-22h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 600,
    d: "M94 677q4 72 36 111.5t85 39.5q34 0 63.5 -17t56 -34t50.5 -17q46 0 59 68h62q-5 -71 -37 -111t-85 -40q-32 0 -61.5 17t-56 34t-51.5 17t-39 -16.5t-20 -51.5h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 600,
    d: "M296 679v4l98 176h118v-4l-143 -176h-73zM88 679v4l96 176h120v-4l-145 -176h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    horizAdvX: 0,
    d: "M337 679l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    horizAdvX: 0,
    d: "M181 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    horizAdvX: 0,
    d: "M108 679v4l137 176h108l139 -176v-4h-80l-114 99l-112 -99h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    horizAdvX: 0,
    d: "M94 677q4 72 36 111.5t85 39.5q34 0 63.5 -17t56 -34t50.5 -17q46 0 59 68h62q-5 -71 -37 -111t-85 -40q-32 0 -61.5 17t-56 34t-51.5 17t-39 -16.5t-20 -51.5h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    horizAdvX: 0,
    d: "M110 711v78h380v-78h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    horizAdvX: 0,
    d: "M300 676q-53 0 -91.5 19t-60.5 54.5t-26 82.5h74q6 -33 30.5 -53t73.5 -20t73.5 20t30.5 53h74q-4 -47 -26 -82.5t-60.5 -54.5t-91.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    horizAdvX: 0,
    d: "M300 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    horizAdvX: 0,
    d: "M421 684q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM179 684q-27 0 -46.5 19.5t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    horizAdvX: 0,
    d: "M300 674q-34 0 -63 16.5t-46 44.5t-17 63t17 63t46 44.5t63 16.5q35 0 63.5 -16.5t45.5 -44.5t17 -63t-17 -63t-45.5 -44.5t-63.5 -16.5zM300 737q25 0 43 17t18 44t-18 44t-43 17t-43 -17t-18 -44t18 -44t43 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    horizAdvX: 0,
    d: "M296 679v4l98 176h118v-4l-143 -176h-73zM88 679v4l96 176h120v-4l-145 -176h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    horizAdvX: 0,
    d: "M245 679l-137 176v4h78l113 -102l113 102h80v-4l-139 -176h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0312",
    unicode: "\u0312",
    horizAdvX: 0,
    d: "M245 694v135q0 51 27 79t79 28h36v-66h-28q-22 0 -34.5 -12t-12.5 -35v-20h46v-109h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M213 -336v66h28q23 0 35 12t12 35v20h-46v109h113v-135q0 -51 -27 -79t-79 -28h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0327",
    unicode: "\u0327",
    horizAdvX: 0,
    d: "M184 -268v76h129v28q0 37 -27 51.5t-71 19.5l63 123h76l-45 -89q41 -8 69.5 -32.5t28.5 -82.5q0 -40 -23.5 -67t-68.5 -27h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    horizAdvX: 0,
    d: "M290 -240q-47 0 -69.5 24t-22.5 68q0 51 35 96.5t77 71.5l63 -20q-40 -32 -60.5 -64t-20.5 -75v-22h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 694,
    d: "M87 -240v840h108v-349q0 -77 38 -120.5t106 -43.5q71 0 113.5 45.5t42.5 119.5v348h108v-600h-107v104h-4q-25 -56 -71 -84.5t-103 -28.5q-35 0 -66 11.5t-56 34.5h-4v-277h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1088,
    d: "M244 0l-208 810h117l152 -657h4l176 657h110l185 -657h4l151 657h117l-208 -810h-118l-185 664h-4l-175 -664h-118zM530 889l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 920,
    d: "M190 0l-172 600h110l126 -467h4l147 467h112l147 -467h4l126 467h108l-172 -600h-120l-148 468h-4l-148 -468h-120zM449 679l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1088,
    d: "M244 0l-208 810h117l152 -657h4l176 657h110l185 -657h4l151 657h117l-208 -810h-118l-185 664h-4l-175 -664h-118zM470 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 920,
    d: "M190 0l-172 600h110l126 -467h4l147 467h112l147 -467h4l126 467h108l-172 -600h-120l-148 468h-4l-148 -468h-120zM389 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1088,
    d: "M244 0l-208 810h117l152 -657h4l176 657h110l185 -657h4l151 657h117l-208 -810h-118l-185 664h-4l-175 -664h-118zM662 894q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM420 894q-27 0 -46.5 19.5 t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 920,
    d: "M190 0l-172 600h110l126 -467h4l147 467h112l147 -467h4l126 467h108l-172 -600h-120l-148 468h-4l-148 -468h-120zM581 684q-28 0 -47.5 19.5t-19.5 46.5t19.5 46.5t47.5 19.5q27 0 46.5 -19.5t19.5 -46.5t-19.5 -46.5t-46.5 -19.5zM339 684q-27 0 -46.5 19.5 t-19.5 46.5t19.5 46.5t46.5 19.5q28 0 47.5 -19.5t19.5 -46.5t-19.5 -46.5t-47.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 816,
    d: "M300 -1v98h189q76 0 122.5 39t46.5 113q0 73 -46 110.5t-122 37.5h-71v75l191 236v4h-395v-712h-110v713q0 47 25 72t72 25h536v-90l-191 -230v-4q65 -6 115 -37.5t78 -82.5t28 -119q0 -75 -34.5 -130.5t-93.5 -85.5t-134 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 700,
    d: "M295 0v305l-283 505h126l213 -390h4l213 390h120l-283 -503v-307h-110zM341 889l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 596,
    d: "M66 -240v86h136l55 151l-251 603h112l191 -469h4l168 469h109l-226 -600l-53 -141q-18 -47 -38.5 -73t-68.5 -26h-138zM287 679l-156 176v4h128l110 -176v-4h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 600,
    d: "M48 254v92h504v-92h-504z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1200,
    d: "M48 251v98h1104v-98h-1104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 268,
    d: "M66 513v176q0 57 31 89t90 32h46v-69h-38q-26 0 -40 -14t-14 -40v-39h61v-135h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 268,
    d: "M35 513v69h38q27 0 40.5 14t13.5 40v40h-61v134h136v-176q0 -57 -31 -89t-90 -32h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 268,
    d: "M35 -162v68h38q27 0 40.5 14t13.5 40v40h-61v134h136v-175q0 -57 -31 -89t-90 -32h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 536,
    d: "M66 513v176q0 57 31 89t90 32h46v-69h-38q-26 0 -40 -14t-14 -40v-39h61v-135h-136zM334 513v176q0 57 31 89t90 32h46v-69h-38q-26 0 -40 -14t-14 -40v-39h61v-135h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 536,
    d: "M35 513v69h38q27 0 40.5 14t13.5 40v40h-61v134h136v-176q0 -57 -31 -89t-90 -32h-46zM303 513v69h38q27 0 40.5 14t13.5 40v40h-61v134h136v-176q0 -57 -31 -89t-90 -32h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 536,
    d: "M35 -162v68h38q27 0 40.5 14t13.5 40v40h-61v134h136v-175q0 -57 -31 -89t-90 -32h-46zM303 -162v68h38q27 0 40.5 14t13.5 40v40h-61v134h136v-175q0 -57 -31 -89t-90 -32h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 620,
    d: "M272 0l-8 272v281l-84 -7h-118v92h118l92 -8l-8 92v118h92v-118l-8 -92l92 8h118v-92h-118l-84 7v-281l-8 -272h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 620,
    d: "M264 0v118l8 92l-92 -8h-118v92h118l90 -8v268l-90 -8h-118v92h118l92 -8l-8 92v118h92v-118l-8 -92l92 8h118v-92h-118l-90 8v-268l90 8h118v-92h-118l-92 8l8 -92v-118h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 421,
    d: "M210 252q-42 0 -77 20.5t-55.5 55.5t-20.5 77q0 43 20.5 77.5t55.5 55t77 20.5q43 0 77.5 -20.5t55 -55t20.5 -77.5q0 -42 -20.5 -77t-55 -55.5t-77.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1200,
    d: "M196 -12q-31 0 -53.5 22.5t-22.5 53.5t22.5 53t53.5 22q32 0 54 -22t22 -53t-22 -53.5t-54 -22.5zM600 -12q-31 0 -53.5 22.5t-22.5 53.5t22.5 53t53.5 22q32 0 54 -22t22 -53t-22 -53.5t-54 -22.5zM1004 -12q-31 0 -53.5 22.5t-22.5 53.5t22.5 53t53.5 22q32 0 54 -22 t22 -53t-22 -53.5t-54 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1452,
    d: "M230 378q-78 0 -126 56.5t-48 165.5t48 165.5t126 56.5q76 0 125 -56.5t49 -165.5t-49 -165.5t-125 -56.5zM230 449q40 0 64 37t24 114t-24 114t-64 37q-41 0 -64.5 -37t-23.5 -114t23.5 -114t64.5 -37zM762 -12q-78 0 -126 56.5t-48 165.5t48 165.5t126 56.5 q76 0 125 -56.5t49 -165.5t-49 -165.5t-125 -56.5zM762 59q40 0 64 37t24 114t-24 114t-64 37q-41 0 -64.5 -37t-23.5 -114t23.5 -114t64.5 -37zM1222 -12q-78 0 -126 56.5t-48 165.5t48 165.5t126 56.5q76 0 125 -56.5t49 -165.5t-49 -165.5t-125 -56.5zM1222 59 q40 0 64 37t24 114t-24 114t-64 37q-41 0 -64.5 -37t-23.5 -114t23.5 -114t64.5 -37zM228 0l446 810h90l-446 -810h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 360,
    d: "M210 55l-172 245l172 245h112l-172 -245l172 -245h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 360,
    d: "M38 55l172 245l-172 245h112l172 -245l-172 -245h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 72,
    d: "M-232 0l446 810h90l-446 -810h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    d: "M372 -12q-78 0 -139.5 35.5t-98.5 102.5t-42 161h-74v73h73v90h-73v73h74q5 94 42 160.5t98.5 102.5t139.5 36q63 0 116.5 -25t91 -75.5t51.5 -128.5h-113q-13 71 -53.5 100.5t-92.5 29.5q-73 0 -120 -50.5t-56 -149.5h243v-73h-244v-90h244v-73h-243q8 -98 55.5 -149 t120.5 -51q54 0 95.5 31.5t54.5 104.5h111q-13 -79 -51 -131.5t-92 -78t-118 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 1012,
    d: "M245 390h-92v336h-139v84h370v-84h-139v-336zM468 390v420h121l114 -297h4l114 297h121v-420h-90v295h-4l-110 -295h-72l-110 296h-5v-296h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    d: "M72 359v92h516v-92h-516z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni004A0301",
    horizAdvX: 450,
    d: "M30 0v98h200v712h110v-709q0 -51 -26.5 -76t-74.5 -25h-209zM214 889v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i.loclTRK",
    horizAdvX: 296,
    d: "M94 0v600h108v-600h-108zM148 682q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni006A0301",
    horizAdvX: 290,
    d: "M-19 -240v86h115v754h108v-739q0 -51 -26.5 -76t-73.5 -25h-123zM79 679v4l108 176h130v-4l-157 -176h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lf",
    horizAdvX: 700,
    d: "M350 -12q-143 0 -217 106t-74 311t74 311t217 106t217 -106t74 -311t-74 -311t-217 -106zM350 84q92 0 137.5 80t45.5 241t-45.5 241t-137.5 80t-137.5 -80t-45.5 -241t45.5 -241t137.5 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lf",
    horizAdvX: 486,
    d: "M254 0v685l-203 -156h-4v113l222 168h93v-810h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lf",
    horizAdvX: 620,
    d: "M47 0v82l305 332q38 42 59.5 71t30.5 54t9 52q0 61 -38.5 98t-101.5 37q-68 0 -110 -42.5t-49 -118.5h-105q5 78 39 135.5t92 89.5t135 32q71 0 126.5 -28.5t87 -80t31.5 -118.5q0 -57 -28 -111t-90 -119l-249 -264v-4h381v-97h-525z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lf",
    d: "M326 -12q-118 0 -189.5 59t-81.5 167h107q6 -62 49 -96t111 -34q70 0 116 40.5t46 109.5q0 66 -45.5 104t-116.5 38h-84v90h90q67 0 102.5 38t35.5 90q0 60 -40.5 96.5t-98.5 36.5q-68 0 -106.5 -37.5t-48.5 -93.5h-103q5 66 39 116.5t91 80t131 29.5q68 0 122.5 -26 t86.5 -74t32 -115q0 -61 -35.5 -108.5t-93.5 -69.5v-4q65 -18 106.5 -68t41.5 -128q0 -77 -35.5 -131t-95.5 -82t-133 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lf",
    horizAdvX: 690,
    d: "M429 0v194h-391v80l393 536h103v-524h118v-92h-118v-194h-105zM148 286h285v383h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lf",
    d: "M325 -12q-118 0 -189.5 59t-81.5 167h107q6 -62 48.5 -96t112.5 -34q73 0 118 48.5t45 125.5q0 78 -45.5 127t-118.5 49q-47 0 -86 -18.5t-62 -50.5h-93l51 445h417v-97h-326l-28 -235h5q26 24 62 36.5t80 12.5q74 0 130.5 -33.5t87.5 -92.5t31 -136q0 -82 -33.5 -144.5 t-93.5 -97.5t-138 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lf",
    horizAdvX: 670,
    d: "M354 -12q-142 0 -218 101.5t-76 289.5q0 138 36 237.5t103 152.5t160 53t160 -50t88 -148h-109q-15 52 -51.5 78t-87.5 26q-86 0 -136.5 -81t-55.5 -230h5q28 50 79 79t112 29q74 0 130.5 -33t88 -92t31.5 -137q0 -81 -32.5 -143t-91 -97t-135.5 -35zM350 82 q69 0 113.5 49t44.5 126q0 50 -22 90t-60.5 63t-89.5 23q-46 0 -82.5 -19.5t-58 -52.5t-21.5 -77q0 -58 23.5 -103.5t63.5 -72t89 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lf",
    horizAdvX: 640,
    d: "M150 0l317 709h-412v101h530v-86l-317 -724h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lf",
    d: "M330 -12q-73 0 -134.5 27.5t-98.5 80.5t-37 129t42 125t96 71v4q-46 22 -80 70.5t-34 108.5q0 69 33 117.5t89 74.5t124 26q69 0 124.5 -26t88.5 -74.5t33 -117.5q0 -60 -34 -105.5t-80 -67.5v-4q55 -22 96.5 -74t41.5 -128t-37 -129t-98.5 -80.5t-134.5 -27.5zM330 82 q44 0 81 18t60 52t23 79t-23 78.5t-60 51.5t-81 18t-81 -18t-60 -51.5t-23 -78.5t23 -79t60 -52t81 -18zM330 471q58 0 99.5 34.5t41.5 94.5t-41.5 94.5t-99.5 34.5t-99.5 -34.5t-41.5 -94.5t41.5 -94.5t99.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lf",
    horizAdvX: 670,
    d: "M315 -12q-104 0 -173 55t-88 157h109q15 -59 55.5 -88.5t97.5 -29.5q80 0 126.5 78.5t50.5 241.5h-4q-25 -46 -73.5 -75.5t-112.5 -29.5q-72 0 -127 32.5t-86 91t-31 134.5q0 78 33.5 138t91 94.5t131.5 34.5q137 0 211.5 -100.5t74.5 -284.5q0 -143 -33.5 -243.5 t-97 -153t-155.5 -52.5zM331 388q68 0 112 41t44 104q0 56 -22 100t-60 70t-86 26q-69 0 -112.5 -47.5t-43.5 -122.5q0 -76 47 -123.5t121 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT",
    horizAdvX: 600,
    d: "M300 292q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT.case",
    horizAdvX: 600,
    d: "M300 292q-28 0 -48 20t-20 48t20 48t48 20t48 -20t20 -48t-20 -48t-48 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C.alt",
    horizAdvX: 0,
    d: "M215 566l64 274h106v-4l-93 -270h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A.case",
    horizAdvX: 0,
    d: "M300 854q-38 0 -70.5 18.5t-51.5 50t-19 70.5q0 40 19 71t51.5 49.5t70.5 18.5q39 0 71 -18.5t51 -49.5t19 -71q0 -39 -19 -70.5t-51 -50t-71 -18.5zM300 923q29 0 49.5 20t20.5 50t-20.5 50t-49.5 20t-49.5 -20t-20.5 -50t20.5 -50t49.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328.e",
    horizAdvX: 0,
    d: "M290 -240q-47 0 -69.5 24t-22.5 68q0 53 35 100t77 75h63q-40 -39 -60.5 -76t-20.5 -87v-25h107v-79h-109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308.narrow",
    horizAdvX: 0,
    d: "M384 685q-25 0 -41 18.5t-16 46.5q0 29 16 47t41 18q26 0 42 -18t16 -47q0 -28 -16 -46.5t-42 -18.5zM216 685q-26 0 -42 18.5t-16 46.5q0 29 16 47t42 18q25 0 41 -18t16 -47q0 -28 -16 -46.5t-41 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304.narrow",
    horizAdvX: 0,
    d: "M170 711v78h260v-78h-260z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: "\u2026",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: "\u201E",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: "\u201A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: ".",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: ",",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: "!",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u1EF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u1E85",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u1E83",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u1E81",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u017E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u017C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u017A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u0177",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u0175",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xFF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xFD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "*",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "!",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u1EF2",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0178",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0176",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\xDD",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "Y",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u1EF2",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0178",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0176",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\xDD",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "Y",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0161",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u010D",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0161",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u010D",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xF6",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xE4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF6",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xF6",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xE4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "*",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "!",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    g2: "seven.lf",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    g2: "six.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    g2: "seven.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    g2: "five.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "seven.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "six.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "four.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "one.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    g2: "six.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    g2: "one.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "five.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "two.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "one.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    u2: "2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "nine.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "five.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "four.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "zero.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    u2: "2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "nine.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "eight.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "six.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "five.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "four.lf",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "three.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "two.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "one.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "zero.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.lf",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.lf",
    g2: "one.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "six.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "two.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "zero.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,J,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Imacron,Iogonek,Idotaccent,IJ,Nacute,uni0145,Ncaron,Eng",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "T,Tcaron,uni021A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "X",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,i,l,igrave,iacute,icircumflex,idieresis,dcroat,imacron,lacute,uni013C,lslash,fi,fl,i.loclTRK",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "T,Tcaron,uni021A",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q,u,ugrave,uacute,ucircumflex,udieresis,dotlessi,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q,u,ugrave,uacute,ucircumflex,udieresis,dotlessi,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q,u,ugrave,uacute,ucircumflex,udieresis,dotlessi,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q,u,ugrave,uacute,ucircumflex,udieresis,dotlessi,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "T,Tcaron,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,endash,emdash",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "f,fi,fl,f_f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "T,Tcaron,uni021A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "t,tcaron,uni021B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "T,Tcaron,uni021A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "f,fi,fl,f_f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "T,Tcaron,uni021A",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "t,tcaron,uni021B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "T,Tcaron,uni021A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "f,fi,fl,f_f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "hyphen,endash,emdash",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "x",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "B,D,E,F,H,I,J,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Edotaccent,Eogonek,Ecaron,Hbar,Imacron,Iogonek,Idotaccent,IJ,uni0136,Lacute,uni013B,Lcaron,Lslash,Nacute,uni0145,Ncaron,Eng,Racute,uni0156,Rcaron",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,Tcaron,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "t,tcaron,uni021B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "T,Tcaron,uni021A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "hyphen,endash,emdash",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "T,Tcaron,uni021A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "t,tcaron,uni021B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "T,Tcaron,uni021A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "hyphen,endash,emdash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "t,tcaron,uni021B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "f,fi,fl,f_f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "hyphen,endash,emdash",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "x",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "f,fi,fl,f_f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "T,Tcaron,uni021A",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "B,D,E,F,H,I,J,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Edotaccent,Eogonek,Ecaron,Hbar,Imacron,Iogonek,Idotaccent,IJ,uni0136,Lacute,uni013B,Lcaron,Lslash,Nacute,uni0145,Ncaron,Eng,Racute,uni0156,Rcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "b,h,i,k,l,germandbls,igrave,iacute,icircumflex,idieresis,thorn,hbar,imacron,ij,uni0137,lacute,uni013C,lcaron,lslash,i.loclTRK",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "f,fi,fl,f_f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "hyphen,endash,emdash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "T,Tcaron,uni021A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "colon,semicolon",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright,bracketright,braceright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j,ij",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "X",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "parenright,bracketright,braceright",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "hyphen,endash,emdash",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "colon,semicolon",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "guillemotleft,guilsinglleft",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "guillemotright,guilsinglright",
    k: 90
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegular);
export default __webpack_public_path__ + "static/media/regular.8077fe8ae52c1b0287d244d7d2d2bca8.svg";
export { ForwardRef as ReactComponent };